
<!--地球页面Globe入方法：影像中心标记创作相关-->

<script>
    import marker_one_red1 from '@/assets/mapbox/marker_image/marker_one/marker_one_red1.png'
    import marker_one_blue1 from '@/assets/mapbox/marker_image/marker_one/marker_one_blue1.png'
    import marker_one_yellow1 from '@/assets/mapbox/marker_image/marker_one/marker_one_yellow1.png'
    import marker_one_green1 from '@/assets/mapbox/marker_image/marker_one/marker_one_green1.png'
    import marker_one_cyan1 from '@/assets/mapbox/marker_image/marker_one/marker_one_cyan1.png'

    import marker_two_red1 from '@/assets/mapbox/marker_image/marker_two/marker_two_red1.png'
    import marker_two_blue1 from '@/assets/mapbox/marker_image/marker_two/marker_two_blue1.png'
    import marker_two_yellow1 from '@/assets/mapbox/marker_image/marker_two/marker_two_yellow1.png'
    import marker_two_green1 from '@/assets/mapbox/marker_image/marker_two/marker_two_green1.png'
    import marker_two_cyan1 from '@/assets/mapbox/marker_image/marker_two/marker_two_cyan1.png'

    import marker_three_red1 from '@/assets/mapbox/marker_image/marker_three/marker_three_red1.png'
    import marker_three_blue1 from '@/assets/mapbox/marker_image/marker_three/marker_three_blue1.png'
    import marker_three_yellow1 from '@/assets/mapbox/marker_image/marker_three/marker_three_yellow1.png'
    import marker_three_green1 from '@/assets/mapbox/marker_image/marker_three/marker_three_green1.png'
    import marker_three_cyan1 from '@/assets/mapbox/marker_image/marker_three/marker_three_cyan1.png'

    import marker_four_red1 from '@/assets/mapbox/marker_image/marker_four/marker_four_red1.png'
    import marker_four_blue1 from '@/assets/mapbox/marker_image/marker_four/marker_four_blue1.png'
    import marker_four_yellow1 from '@/assets/mapbox/marker_image/marker_four/marker_four_yellow1.png'
    import marker_four_green1 from '@/assets/mapbox/marker_image/marker_four/marker_four_green1.png'
    import marker_four_cyan1 from '@/assets/mapbox/marker_image/marker_four/marker_four_cyan1.png'

    import marker_five_red1 from '@/assets/mapbox/marker_image/marker_five/marker_five_red1.png'
    import marker_five_blue1 from '@/assets/mapbox/marker_image/marker_five/marker_five_blue1.png'
    import marker_five_yellow1 from '@/assets/mapbox/marker_image/marker_five/marker_five_yellow1.png'
    import marker_five_green1 from '@/assets/mapbox/marker_image/marker_five/marker_five_green1.png'
    import marker_five_cyan1 from '@/assets/mapbox/marker_image/marker_five/marker_five_cyan1.png'

    import marker_six_red1 from '@/assets/mapbox/marker_image/marker_six/marker_six_red1.png'
    import marker_six_blue1 from '@/assets/mapbox/marker_image/marker_six/marker_six_blue1.png'
    import marker_six_yellow1 from '@/assets/mapbox/marker_image/marker_six/marker_six_yellow1.png'
    import marker_six_green1 from '@/assets/mapbox/marker_image/marker_six/marker_six_green1.png'
    import marker_six_cyan1 from '@/assets/mapbox/marker_image/marker_six/marker_six_cyan1.png'

    import marker_seven_red1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_red1.png'
    import marker_seven_blue1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_blue1.png'
    import marker_seven_yellow1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_yellow1.png'
    import marker_seven_green1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_green1.png'
    import marker_seven_cyan1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_cyan1.png'

    import marker_eight_red1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_red1.png'
    import marker_eight_blue1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_blue1.png'
    import marker_eight_yellow1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_yellow1.png'
    import marker_eight_green1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_green1.png'
    import marker_eight_cyan1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_cyan1.png'

    import marker_nine_red1 from '@/assets/mapbox/marker_image/marker_nine/marker_nine_red1.png'
    import marker_nine_blue1 from '@/assets/mapbox/marker_image/marker_nine/marker_nine_blue1.png'
    import marker_nine_yellow1 from '@/assets/mapbox/marker_image/marker_nine/marker_nine_yellow1.png'
    import marker_nine_green1 from '@/assets/mapbox/marker_image/marker_nine/marker_nine_green1.png'
    import marker_nine_cyan1 from '@/assets/mapbox/marker_image/marker_nine/marker_nine_cyan1.png'

    import * as turf from '@turf/turf'
    import mapboxgl from "mapbox-gl";

    export default {
  name: "GlobeMarker",
    data(){
      return{
          drawToolsOldChose:"selectTool",
          //选择哪个绘图工具
          drawToolsChoose:'selectTool',
          drawToolsList:[
              {name:'selectTool', icon:'&#xe676;',text:'选择',snackbarText:'点击地图标记进行选择'},
              {name:'markerTool', icon:'&#xe677;',text:'点位标记',snackbarText:'点击地图进行标记'},
              {name:'lineTool', icon:'&#xe675;',text:'直线标记',snackbarText:'点击地图进行标记，双击完成标记，按ESC键取消标记 '},
              {name:'roadTool', icon:'&#xe679;',text:'路线规划',snackbarText:'点击地图开始规划，双击完成规划，按ESC键取消规划'},
              {name:'circleTool', icon:'&#xe67b;',text:'圆形标记',snackbarText:'点击地图开始标记再次点击完成标记'},
              {name:'rectangleTool', icon:'&#xe67a;',text:'矩形标记',snackbarText:'点击地图开始标记再次点击完成标记'},
              {name:'polygonTool', icon:'&#xe678;',text:'多边形标记',snackbarText:'点击地图进行标记，双击完成标记，按ESC键取消标记'},
              {name:'areaTool', icon:'&#xe67c;',text:'行政区域',snackbarText:'点击区域后开始添加区域图形标记'},
          ],
          //点集合
          markerList:{
              'type': 'FeatureCollection',
              'features': []
          },
          //线集合
          lineJson:{
              linePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              lineGeo:{
                  "type": "FeatureCollection",
                  "features": []
              },
              lineNamePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              }
          },
          //路线集合
          roadJson:{
              roadPoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              roadGeo:{
                  "type": "FeatureCollection",
                  "features": []
              },
              roadNamePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              }
          },
          //四边形集合
          polygonJson:{
              polygonPoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              polygonGeo:{
                  "type": "FeatureCollection",
                  "features": []
              },
              polygonNamePoint:{
                  "type": "FeatureCollection",
                  "features": []
              },
              polygonLenPoint:{
                  "type": "FeatureCollection",
                  "features": []
              },
              circleRadiusPoint:{
                  "type": "FeatureCollection",
                  "features": []
              }
          },
          propertiesEditCardShow:false,//编辑卡片是否显示
          isEditName:false,//是否编辑名称
          editNameText:'',
          isEditAddr:false,//是否编辑地点
          editAddrText:'',
          isEditRemark:false,//是否编辑备注
          editRemarkText:'',
          settingShow:false,
          pointInfoShow:false,
          circleRadiusCardShow:false,
          circleRadiusCardTop:"",
          circleRadiusCardLeft:"",
          circleRadiusText:'',
          selectItems:{
              points:[],
              geo:{
                  type:'Feature',
                  id: '',//id
                  geometry: {
                      type: '',
                      coordinates: []
                  },
                  properties: {
                      "id":'',
                      "type":'',//类型
                      "name":"",//名字
                      "code": '',//对应的图标
                      "color": '',//颜色
                      "remark": "",//备注
                      "visible":"",//是否显示，控制白点是否显示
                      "country":'',//国家名
                      "addrName":'',//地名
                      "imageList":[],//存储图片视频
                      "size":1,//图标大小
                      "len":0,////长度或者周长或者半径
                      "width":1,//线段宽度
                      "area":0,//面积大小
                      "lineColor":'',//线段
                      "center":[],//中心点
                      "graphArea":'',//图形区域
                      'userId':'',
                      'nickName':'',
                  },
              }
          },//被选择的geo
          editSelectItems:{
              points:[],
              geo:{
                  type:'Feature',
                  id: '',//id
                  geometry: {
                      type: '',
                      coordinates: []
                  },
                  properties: {
                      "id":'',
                      "type":'',//类型
                      "name":"",//名字
                      "code": '',//对应的图标
                      "color": '',//颜色
                      "remark": "",//备注
                      "visible":"",//是否显示，控制白点是否显示
                      "country":'',//国家名
                      "addrName":'',//地名
                      "imageList":[],//存储图片视频
                      "size":1,//图标大小
                      "len":0,////长度或者周长或者半径
                      "width":1,//线段宽度
                      "area":0,//面积大小
                      "lineColor":'',//线段
                      "center":[],//中心点
                      "graphArea":'',//图形区域
                      'userId':'',
                      'nickName':'',
                  },
              }
          },
          //是否画
          isDraw:false,
          //辅助 存点，线
          jsonPoint:{
              'type': 'FeatureCollection',
              'features': []
          },
          jsonLine : {
              'type': 'FeatureCollection',
              'features': []
          },
          jsonTemp : {
              "type": "Feature",
              "id": '',
              "properties": {
                  "id":'',
                  "type":'',//类型
                  "name":"",//名字
                  "code": '',//对应的图标
                  "color": '',//颜色
                  "remark": "",//备注
                  "visible":"",//是否显示，控制白点是否显示
                  "country":'',//国家名
                  "addrName":'',//地名
                  "imageList":[],//存储图片视频
                  "size":1,//图标大小
                  "len":0,////长度或者周长或者半径
                  "width":1,//线段宽度
                  "area":0,//面积大小
                  "lineColor":'',//线段
                  "center":[],
                  "graphArea":'',//中心点
                  'userId':'',
                  'nickName':'',
              },
              "geometry": {
                  "coordinates": [],
                  "type": "LineString"
              }
          },
          polygonFeatureCollection:{
              type:"FeatureCollection",
              features:[]
          },
          pointArray:[],//存储点坐标的数组
          flag:false,//标志
          measureCardShow:false,//测量card变量
          measureToolChoose:'',
          jsonNamePoint:{
              'type': 'FeatureCollection',
              'features': []
          },
          measureLengthJson:{
              measurePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              measureGeo:{
                  "type": "FeatureCollection",
                  "features": []
              },
              measureNamePoint:{
                  "type": "FeatureCollection",
                  "features": []
              },
              measureStartAndEndPoint:{
                  "type": "FeatureCollection",
                  "features": []
              }
          },
          measureAreaJson:{
              measurePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              measureGeo:{
                  "type": "FeatureCollection",
                  "features": []
              },
              measureNamePoint:{
                  "type": "FeatureCollection",
                  "features": []
              }
          },
          mapMarker:'',//长度测量用来展示长度
          mapStartMarker:'',//度测量用来每一个的起点
          popup:'',//用来展示行政区域的名字
          isMousemove:false,//是否移動
          pointCoord:[],
          currentBoundary:{},//当前边界
          currentSelect:0,//当前选项
          currentChildrenList:{
              "type": "FeatureCollection",
              "features": [],
          },
          hoveredStateId:null,
          boundaryArray:[],//边界的数组
          boundaryChildrenArray:[],//边界子集的数组
          canClick:true,//是否可以
          areaCardShow:false,
          areaName:'-',//暂存行政区域所属区域
          provinceItems:[],
          cityItems:[],
          countyItems:[],
          provinceNow: '',
          cityNow: '',
          countyNow: '',
          isEditArea:false,
          hoverNodeId:'',
          hideFlag:0,
          removeFlag:0,
          roadClickLength:0,
          isEditMarker:false,//是否编辑卡片
          notSavedDialog:false,//未保存弹窗
          //''''''''''''''''''''''''''图层列表的内容''''''''''''''''''''''''''''''''''''
          importAnnexDataDialogShow:false,//导入数据弹窗

          layerCardShow:false,
          layerCardTypeSelect:'',//
          isViewAnnexData:false,
          messageQueue:[
             /* {
                  "avatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png",
                  "nickName": "创作者我",
                  "operation": "删除了111"
              },
              {
                  "avatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png",
                  "nickName": "创作者dfdfdf",
                  "operation": "删除了222"
              },
              {
                  "avatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png",
                  "nickName": "创作者272fdaf",
                  "operation": "删除了3333"
              },
              {
                  "avatar": "https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202108301117000116048_thumb.png",
                  "nickName": "创作者2727967",
                  "operation": "删除了4444"
              }*/
          ],//存储接收到的消息
          messageShowQueue:[],
          messageTime:'',
          messageShowTime:0,

          rules: [v => v.length <= 20],
          rules1:[v => v.length <= 30],
          rules2:[v => v.length <= 100],
          showDelete:true,
      }
    },
    computed:{
        deleteNode(){
          return this.$store.state.deleteNode
        },
        selectNode(){
            return this.$store.state.selectNode
        },
        hideControlNode(){
            return this.$store.state.hideControlNode
        },
        selectLayerTreeNode(){
            return this.$store.state.selectLayerTreeNode
        }
    },
    watch:{
        deleteNode(){
            if(this.deleteNode !==''){
                if(this.deleteNode.id ===this.selectNode.id){
                    this.$store.state.selectNode =''
                    this.closeEditCard()
                }
                if(this.deleteNode.data.type !=='folder'){
                    this.removerMarker1(this.deleteNode)
                }else {
                   this.removeFlag = this.removeFolderMarker(this.deleteNode)
                }
            }
        },
        removeFlag(){
            if(this.removeFlag === 1){
                this.mapSetData()
                this.removeFlag = 0
            }
        },
        selectNode(){
            if(this.$store.state.handleNodeOption === 'selectNode'){
                this.closeEditCard()
                if(this.selectNode !==''&&this.selectNode.data.visible){
                    if(this.selectNode.data.type !=='folder'){
                        //如何hover情况下被选中
                        // if(this.selectNode.data.id === this.hoverNodeId){
                        //     if(this.selectNode.data.type ==='point'){
                        //         this.selectNode.data.geoJson.geo.properties.size = this.selectNode.data.geoJson.geo.properties.size -1
                        //     }else{
                        //         this.selectNode.data.geoJson.geo.properties.width = this.selectNode.data.geoJson.geo.properties.width-2
                        //     }
                        // }
                        if(this.selectNode.data.type ==='administrativeArea'){
                            this.currentBoundary.geometry.type = this.deepClone(this.selectNode.data.geoJson.geo.geometry.type)
                            this.currentBoundary.properties.center = this.deepClone(this.selectNode.data.geoJson.geo.properties.center)
                            this.currentBoundary.geometry.coordinates = this.deepClone(this.selectNode.data.geoJson.geo.geometry.coordinates)
                            this.areaName =  this.deepClone(this.selectNode.data.geoJson.geo.properties.graphArea)
                        }
                      // this.selectItems.geo = this.deepClone(this.selectNode.data.geoJson.geo)
                        //展示的
                        this.selectItems.geo = this.selectNode.data.geoJson.geo
                        this.selectItems.points = this.deepClone(this.selectNode.data.geoJson.points)
                        //用来修改的备用的
                        this.editSelectItems.geo =this.deepClone(this.selectNode.data.geoJson.geo)
                        this.editSelectItems.points =this.deepClone(this.selectNode.data.geoJson.points)
                        this.propertiesEditCardShow = true
                        this.mapFitBoundary(this.selectNode.data.geoJson.geo, this.selectNode.data.type)

                        //地图数据处理
                        if(this.selectNode.data.type ==='point'){
                            this.mapMarkerStatus(this.selectNode.data.id,this.selectNode.data.geoJson.geo.properties.size)
                        }else{
                            this.mapMarkerStatus(this.selectNode.data.id,this.selectNode.data.geoJson.geo.properties.width)
                        }
                    }else{
                        this.mapMarkerStatus(this.selectNode.data.id,2)
                        this.closeEditCard()
                    }
                }else{
                    this.closeEditCard()
                }
            }
        },
        selectLayerTreeNode(){
            if(this.selectLayerTreeNode !==''){
                this.layerCardShow = true
                this.layerCardTypeSelect = ''
                setTimeout(()=>this.layerCardTypeSelect = this.deepClone(this.selectLayerTreeNode.data.style),10)
               // this.layerCardTypeSelect = this.deepClone(this.selectLayerTreeNode.data.style)
            }else{
                this.layerCardShow = false
                this.layerCardTypeSelect=''
            }
        },

        'hideControlNode.data.visible':{
            deep: true,
            handler(){
                if(this.hideControlNode.data.type !=='folder'){
                    this.hideControlMarkerN1(this.hideControlNode)
                }else{
                    this.hideFlag=this.hideControlFolderMarker(this.hideControlNode)
                }
            }
        },
        hideFlag(){
            if(this.hideFlag ===1){
                this.mapSetData()
                this.hideFlag = 0
            }
        },
    },
  methods:{
      //选中
      selectValue(e){
          e.currentTarget.select()
      },
      //创作标记引导视频  更换视频njh
      openMarkerGuideVideo(){
          this.fullScreenVideoSrc = "https://market.obs.cn-north-4.myhuaweicloud.com/webGuide/web/biaoji.mp4";
          this.fullScreenVideoShow = true;
          this.fullScreenVideoVIf = true;

    },
      globeMarkerFun(){
        this.loadIconImage();
        //加载地图上的点
        this.map.addSource('markerLayer',{
            type:"geojson",
            data:this.markerList
        })
        this.map.addLayer({
            "id": "markerList2",
            "type": "symbol",
            "source": "markerLayer",
            "layout":{
                "icon-size":['get', 'size'],
                "icon-anchor":"bottom",
                "icon-image":[
                    'match',
                    ["concat", ['get', 'code'],['get', 'color']],

                    '&#xe6b6;#FF0000','marker_one_red1',
                    '&#xe6b6;#FFC800','marker_one_yellow1',
                    '&#xe6b6;#2A82E4','marker_one_blue1',
                    '&#xe6b6;#00FF00','marker_one_green1',
                    '&#xe6b6;#00FFFF','marker_one_cyan1',

                    '&#xe657;#FF0000','marker_two_red1',
                    '&#xe657;#FFC800','marker_two_yellow1',
                    '&#xe657;#2A82E4','marker_two_blue1',
                    '&#xe657;#00FF00','marker_two_green1',
                    '&#xe657;#00FFFF','marker_two_cyan1',

                    '&#xe653;#FF0000','marker_three_red1',
                    '&#xe653;#FFC800','marker_three_yellow1',
                    '&#xe653;#2A82E4','marker_three_blue1',
                    '&#xe653;#00FF00','marker_three_green1',
                    '&#xe653;#00FFFF','marker_three_cyan1',

                    '&#xe65a;#FF0000','marker_four_red1',
                    '&#xe65a;#FFC800','marker_four_yellow1',
                    '&#xe65a;#2A82E4','marker_four_blue1',
                    '&#xe65a;#00FF00','marker_four_green1',
                    '&#xe65a;#00FFFF','marker_four_cyan1',

                    '&#xe63c;#FF0000','marker_five_red1',
                    '&#xe63c;#FFC800','marker_five_yellow1',
                    '&#xe63c;#2A82E4','marker_five_blue1',
                    '&#xe63c;#00FF00','marker_five_green1',
                    '&#xe63c;#00FFFF','marker_five_cyan1',

                    '&#xe651;#FF0000','marker_six_red1',
                    '&#xe651;#FFC800','marker_six_yellow1',
                    '&#xe651;#2A82E4','marker_six_blue1',
                    '&#xe651;#00FF00','marker_six_green1',
                    '&#xe651;#00FFFF','marker_six_cyan1',

                    '&#xe664;#FF0000','marker_seven_red1',
                    '&#xe664;#FFC800','marker_seven_yellow1',
                    '&#xe664;#2A82E4','marker_seven_blue1',
                    '&#xe664;#00FF00','marker_seven_green1',
                    '&#xe664;#00FFFF','marker_seven_cyan1',

                    '&#xe654;#FF0000','marker_eight_red1',
                    '&#xe654;#FFC800','marker_eight_yellow1',
                    '&#xe654;#2A82E4','marker_eight_blue1',
                    '&#xe654;#00FF00','marker_eight_green1',
                    '&#xe654;#00FFFF','marker_eight_cyan1',

                    '&#xe656;#FF0000','marker_nine_red1',
                    '&#xe656;#FFC800','marker_nine_yellow1',
                    '&#xe656;#2A82E4','marker_nine_blue1',
                    '&#xe656;#00FF00','marker_nine_green1',
                    '&#xe656;#00FFFF','marker_nine_cyan1',

                    'marker_one_blue1'
                ],
                "text-font":this.$store.state.font,
                "text-field": ["get", "name"],
                "text-size":16,
                "text-anchor": "bottom",
                // "text-offset": [0, -2.3],
                "text-offset":[ 'interpolate',
                    ["linear"],
                    ['get', 'size'],
                    0.5,
                    ["literal", [0, -2.5]],
                    0.7,
                    ["literal", [0, -5]],
                    0.9,
                    ["literal", [0, -5]],
                    1.1,
                    ["literal", [0, -7.4]],
                ],
                "icon-allow-overlap":true,
                "text-allow-overlap":true,
                "visibility":'visible',
            },
            "filter":['==','visible','visible'],
            "paint":{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
                "icon-opacity": 1,
                //"icon-color":["get", "color"],
                // "icon-halo-color":'rgba(0, 0, 0, 1)',
                // "icon-halo-blur":2,
                // "icon-halo-width":1.5,
            }
        },)//点
        // this.map.addLayer({
        //     "id":"markerList1",
        //     "type":"circle",
        //     "source": "markerLayer",
        //     "layout":{
        //         "visibility":'visible',
        //     },
        //     "filter":['==','visible','visible'],
        //     "paint": {
        //         "circle-radius": [
        //             'interpolate',
        //             ["linear"],
        //             ['get', 'size'],
        //             0,6,1.4,7,1.8,8,2.2,9
        //         ],
        //         "circle-color":'#ffffff',
        //         "circle-translate":[0,-4],
        //         //"circle-translate-anchor":"map",
        //     },
        // })

        this.map.on('click','markerList2',this.clickMapMarker)

        //加载地图上的线
        this.map.addSource('linePointLayer',{
            type:"geojson",
            data:this.lineJson.linePoint
        })
        this.map.addSource('lineLayer',{
            type:"geojson",
            data:this.lineJson.lineGeo
        })
        this.map.addSource('lineNamePoint',{
            type:"geojson",
            data:this.lineJson.lineNamePoint
        })
        this.map.addLayer({
            id:'lineNamePoint',
            type:'symbol',
            source: 'lineNamePoint',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "top",
                "text-offset": [-1.3,1],
                "visibility":'visible',
                "icon-allow-overlap":true,
                "text-allow-overlap":true,
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'markerList2')//线名
        this.map.addLayer({
            id: 'linePointLayer',
            type: 'circle',
            source: 'linePointLayer',
            layout:{
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'circle-color': ["get", "color"],
                'circle-radius': 5,
                'circle-stroke-width': 3,
                'circle-stroke-color': '#ffffff'
            }
        },'lineNamePoint');//线-点
        this.map.addLayer({
            id:'linePointSymbol',
            type:'symbol',
            source: 'linePointLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "bottom",
                "text-offset": [0,-0.8],
                "visibility":'visible',
                "icon-allow-overlap":true,
                "text-allow-overlap":true,
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'linePointLayer')//点名
        this.map.addLayer({
            id: 'lineLayer',
            type: 'line',
            source: 'lineLayer',
            layout:{
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'line-color': ["get", "color"],
                'line-width':["get", "width"],
                'line-opacity': 1,
               // 'line-blur':5,
            }
        },'linePointSymbol')//线

        this.map.on('click','lineLayer',this.clickMapMarker)
        //加载地图上路线规划
        this.map.addSource('roadPointLayer',{
            type:"geojson",
            data:this.roadJson.roadPoint
        })
        this.map.addSource('roadLayer',{
            type:"geojson",
            data:this.roadJson.roadGeo
        })
        this.map.addSource('roadNamePoint',{
            type:"geojson",
            data:this.roadJson.roadNamePoint
        })
        this.map.addLayer({
            id:'roadNamePoint',
            type:'symbol',
            source: 'roadNamePoint',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "top",
                "text-offset": [-1.3,1],
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'lineLayer')
        this.map.addLayer({
            id: 'roadPointLayer',
            type: 'circle',
            source: 'roadPointLayer',
            layout:{
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'circle-color':["get", "color"],
                'circle-radius': 5,
                'circle-stroke-width': 3,
                'circle-stroke-color': '#ffffff'
            }
        },'roadNamePoint');
        this.map.addLayer({
            id:'roadPointSymbol',
            type:'symbol',
            source: 'roadPointLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "bottom",
                "text-offset": [0,-0.8],
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'roadPointLayer')
        this.map.addLayer({
            id: 'roadLayer',
            type: 'line',
            source: 'roadLayer',
            layout:{
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'line-color': ["get", "color"],
                'line-width':["get", "width"],
                'line-opacity': 1
            }
        },'roadPointSymbol')

        this.map.on('click','roadLayer',this.clickMapMarker)
        //加载地图上的多边形
        this.map.addSource('polygonLayer',{
            type:"geojson",
            data:this.polygonJson.polygonGeo
        })
        this.map.addSource('polygonPointLayer',{
            type:"geojson",
            data:this.polygonJson.polygonPoint
        })
        this.map.addSource('polygonNameLayer',{
            type:"geojson",
            data:this.polygonJson.polygonNamePoint
        })
        this.map.addSource('polygonLenLayer',{
            type:"geojson",
            data:this.polygonJson.polygonLenPoint
        })
        this.map.addSource('circleRadiusPoint',{
            type:"geojson",
            data:this.polygonJson.polygonLenPoint
        })
        this.map.addLayer({
            id:'circleRadiusPoint',
            type:'symbol',
            source: 'circleRadiusPoint',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "left",
                "text-offset": [1,0],
                "text-line-height":2,
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'roadLayer')//圆半径
        this.map.addLayer({
            id:'polygonNameLayer',
            type:'symbol',
            source: 'polygonNameLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "center",
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'circleRadiusPoint')//名字
        this.map.addLayer({
            id: 'polygonPointLayer',
            type: 'circle',
            source: 'polygonPointLayer',
            layout: {
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'circle-color': ["get", "color"],
                'circle-radius': 5,
                'circle-stroke-width': 3,
                'circle-stroke-color': '#ffffff'
            }
        },'polygonNameLayer')//点
        this.map.addLayer({
            id:'polygonPointSymbol',
            type:'symbol',
            source: 'polygonPointLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "bottom",
                "text-offset": [0,-0.8],
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'polygonPointLayer')//点名
        this.map.addLayer({
            id:'polygonLenLayer',
            type:'symbol',
            source: 'polygonLenLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":16,
                "text-anchor": "center",
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":3,
                "text-halo-width": 1,
            }
        },'polygonPointSymbol')//线名
        this.map.addLayer({
            id: 'polygonLineLayer',
            type: 'line',
            source: 'polygonLayer',
            layout: {
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'line-color': ["get", "lineColor"],
                'line-width': ["get", "width"]
            }
        },'polygonLenLayer')//线
        this.map.addLayer({
            id: 'polygonLayer',
            type: 'fill',
            source: 'polygonLayer',
            layout: {
                "visibility":'visible',
            },
            filter:['==','visible','visible'],
            paint: {
                'fill-color':["get", "color"],
                'fill-opacity': 0.5,
            }
        },'polygonLineLayer')//多边形

        this.map.on('click','polygonLayer',this.clickMapMarker)
        //测量数据
        this.map.addSource('measurePoints', {
            type: 'geojson',
            data: this.measureLengthJson.measurePoint
        });
        this.map.addSource('measureLine', {
            type: 'geojson',
            data: this.measureLengthJson.measureGeo
        });
        this.map.addSource('measureLineName',{
            type: 'geojson',
            data: this.measureLengthJson.measureNamePoint
        })
        this.map.addLayer({
            id: 'measurePoints',
            type: 'circle',
            source: 'measurePoints',
            paint: {
                'circle-color': '#00BAAD',
                'circle-radius': 5,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#ffffff'
            }
        });
        // this.map.addLayer({
        //     id: 'measureLineFirstName',
        //     type: 'symbol',
        //     source: 'measurePoints',
        //     layout:{
        //         "text-field": ["get", "name"],
        //         "text-size":14,
        //         "text-anchor": "top",
        //         "text-offset": [0,-2],
        //     },
        //     paint:{
        //         "text-color": "#ffffff",
        //         "text-halo-color":'rgba(0, 0, 0, 1)',
        //         "text-halo-blur":1,
        //         "text-halo-width": 1,
        //     }
        // })
        this.map.addLayer({
            id: 'measureLine',
            type: 'line',
            source: 'measureLine',
            paint: {
                'line-color': '#00BAAD',
                'line-width': 2,
                'line-opacity': 1
            }
        });
        this.map.addLayer({
            id: 'measureLineName',
            type: 'symbol',
            source: 'measureLineName',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":14,
                "text-anchor": "center",
            },
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":1,
                "text-halo-width": 2,
            }
        })

        this.map.addSource('measureAreaLayer',{
            type:"geojson",
            data:this.measureAreaJson.measureGeo
        })
        this.map.addSource('measureAreaPointLayer',{
            type:"geojson",
            data:this.measureAreaJson.measurePoint
        })
        this.map.addSource('measureAreaNameLayer',{
            type:"geojson",
            data:this.measureAreaJson.measureNamePoint
        })
        this.map.addLayer({
            id: 'measureAreaLayer',
            type: 'fill',
            source: 'measureAreaLayer',
            layout: {},
            paint: {
                'fill-color':"#00BAAD",
                'fill-opacity': 0.5,
            }
        })
        this.map.addLayer({
            id: 'measureAreaLineLayer',
            type: 'line',
            source: 'measureAreaLayer',
            layout: {},
            paint: {
                'line-color': "#00BAAD",
                'line-width': 1
            }
        })
        this.map.addLayer({
            id: 'measureAreaPointLayer',
            type: 'circle',
            source: 'measureAreaPointLayer',
            paint: {
                'circle-color': '#00BAAD',
                'circle-radius': 5,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#ffffff'
            }
        })
        this.map.addLayer({
            id: 'measureAreaNameLayer',
            type: 'symbol',
            source: 'measureAreaNameLayer',
            layout:{
                "text-field": ["get", "name"],
                "text-font":this.$store.state.font,
                "text-size":14,
                "text-anchor": "center",
            },
            paint:{
                "text-color": "#ffffff",
                "text-halo-color":'rgba(0, 0, 0, 1)',
                "text-halo-blur":1,
                "text-halo-width": 1,
            }
        })
    },
      //点击标记方法
      clickMapMarker(e){
          if(this.drawToolsChoose ==='selectTool'){
              this.$store.state.handleNodeOption = 'selectNode'
              this.$refs.mainGlobeOperation.addMarkerToSelect(e.features[0].properties.id)
          }
      },
      //加载地图图片
      loadIconImage(){
        const _this=this;
        //第一个图标
          this.map.loadImage(
              marker_one_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_one_red1',image)
              }
          )

          this.map.loadImage(
              marker_one_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_one_blue1',image)
              }
          )

          this.map.loadImage(
              marker_one_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_one_yellow1',image)
              }
          )

          this.map.loadImage(
              marker_one_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_one_green1',image)
              }
          )

          this.map.loadImage(
              marker_one_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_one_cyan1',image)
              }
          )
          //第二个图标
          this.map.loadImage(
              marker_two_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_two_red1',image)
              }
          )
          this.map.loadImage(
              marker_two_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_two_blue1',image)
              }
          )
          this.map.loadImage(
              marker_two_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_two_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_two_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_two_green1',image)
              }
          )
          this.map.loadImage(
              marker_two_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_two_cyan1',image)
              }
          )
          //第三个个图标
          this.map.loadImage(
              marker_three_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_three_red1',image)
              }
          )
          this.map.loadImage(
              marker_three_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_three_blue1',image)
              }
          )
          this.map.loadImage(
              marker_three_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_three_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_three_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_three_green1',image)
              }
          )
          this.map.loadImage(
              marker_three_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_three_cyan1',image)
              }
          )
          //第四个图标
          this.map.loadImage(
              marker_four_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_four_red1',image)
              }
          )
          this.map.loadImage(
              marker_four_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_four_blue1',image)
              }
          )
          this.map.loadImage(
              marker_four_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_four_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_four_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_four_green1',image)
              }
          )
          this.map.loadImage(
              marker_four_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_four_cyan1',image)
              }
          )
          //第五个图标
          this.map.loadImage(
              marker_five_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_five_red1',image)
              }
          )
          this.map.loadImage(
              marker_five_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_five_blue1',image)
              }
          )
          this.map.loadImage(
              marker_five_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_five_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_five_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_five_green1',image)
              }
          )
          this.map.loadImage(
              marker_five_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_five_cyan1',image)
              }
          )
          //第六个图标
          this.map.loadImage(
              marker_six_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_six_red1',image)
              }
          )
          this.map.loadImage(
              marker_six_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_six_blue1',image)
              }
          )
          this.map.loadImage(
              marker_six_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_six_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_six_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_six_green1',image)
              }
          )
          this.map.loadImage(
              marker_six_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_six_cyan1',image)
              }
          )
          //第7个图标
          this.map.loadImage(
              marker_seven_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_seven_red1',image)
              }
          )
          this.map.loadImage(
              marker_seven_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_seven_blue1',image)
              }
          )
          this.map.loadImage(
              marker_seven_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_seven_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_seven_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_seven_green1',image)
              }
          )
          this.map.loadImage(
              marker_seven_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_seven_cyan1',image)
              }
          )
          //第8个图标
          this.map.loadImage(
              marker_eight_red1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_eight_red1',image)
              }
          )
          this.map.loadImage(
              marker_eight_blue1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_eight_blue1',image)
              }
          )
          this.map.loadImage(
              marker_eight_yellow1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_eight_yellow1',image)
              }
          )
          this.map.loadImage(
              marker_eight_green1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_eight_green1',image)
              }
          )
          this.map.loadImage(
              marker_eight_cyan1,
              function (error,image) {
                  if(error) throw error
                  _this.map.addImage('marker_eight_cyan1',image)
              }
          )
        //第9个图标
        this.map.loadImage(
            marker_nine_red1,
            function (error,image) {
              if(error) throw error
              _this.map.addImage('marker_nine_red1',image)
            }
        )
        this.map.loadImage(
            marker_nine_blue1,
            function (error,image) {
              if(error) throw error
              _this.map.addImage('marker_nine_blue1',image)
            }
        )
        this.map.loadImage(
            marker_nine_yellow1,
            function (error,image) {
              if(error) throw error
              _this.map.addImage('marker_nine_yellow1',image)
            }
        )
        this.map.loadImage(
            marker_nine_green1,
            function (error,image) {
              if(error) throw error
              _this.map.addImage('marker_nine_green1',image)
            }
        )
        this.map.loadImage(
            marker_nine_cyan1,
            function (error,image) {
              if(error) throw error
              _this.map.addImage('marker_nine_cyan1',image)
            }
        )
      },
      //选择了哪一个操作
      selectDrawTools(val,text){
        //清除测量的数据
        this.clearAllMeasure()

          if(this.$store.state.handleNodeOption === 'modify'){
              this.notSavedDialog = true
          }else{
              //进入到数据列表页面
              this.$refs.mainGlobeOperation.successToData()
              if(this.drawToolsOldChose !==val){
                  this.drawToolsChoose = val
                  this.drawToolsOldChose = val
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = text
                  this.$store.state.snackbarType = 'info'

                  if(val ==='markerTool'){
                      this.addMarker(this.drawToolsOldChose)
                  }else if(val === 'lineTool'){
                      this.addLine()
                  }else if(val === 'rectangleTool')
                      this.addRectangle()
                  else if(val === 'polygonTool')
                      this.addPolygon()
                  else if(val === 'circleTool')
                      this.addCircle()
                  else if(val === 'roadTool')
                      this.addRoad()
                  else if(val === 'areaTool')
                      this.addAdministrativeArea()
                  else if(val === 'selectTool'){
                      this.cleanMapOnEvent()
                      this.map.getCanvas().style.cursor = 'default'
                      document.getElementById("labelCanvas").style.cursor = 'default';
                  }

              }else{
                  this.drawToolsOldChose = 'selectTool'
                  this.drawToolsChoose = 'selectTool'
                  this.cleanMapOnEvent()
                  this.map.getCanvas().style.cursor = 'default'
                  document.getElementById("labelCanvas").style.cursor = 'default';

              }
          }

          // if(this.$store.state.currFolderTeamReadonly === 1 && this.$store.state.currFolderRole !==1){
          //     this.$store.state.snackbarShow=true
          //     this.$store.state.snackbarText = "暂无权限，请联系创建者"
          //     this.$store.state.snackbarType = 'error'
          // }else {
          //
          //
          // }
      },
      //选择导入数据操作

      cleanMapOnEvent(){
          this.finishMarkerDraw()
          this.finishLineDraw()
          this.finishRoadDraw()
          this.finishCircleDraw()
          this.finishRectangleDraw()
          this.finishPolygonDraw()
          //this.finishDrawArea()
          this.closeAreaDraw()
          this.clearLayerAndSource()
          document.removeEventListener('keyup', this.keyupEvent);
      },

      //调用接口，新增节点
     async addLabel(temp,points,succMethod,failedMethod){
          let parentNodeId
          if(this.selectNode  === ''){
              parentNodeId = ''
          }else{
              if(this.selectNode.data.type !=='folder'){
                  if(this.selectNode.parent ===null){
                      parentNodeId = ''
                  }else{
                      if(Array.isArray(this.selectNode.parent.data)){

                          parentNodeId =  ''
                         // this.selectNode.parent.data.push(data)
                      }else{
                          parentNodeId =  this.selectNode.parent.data.id
                          //this.selectNode.parent.data.children.push(data)
                      }
                  }
              }else{
                  parentNodeId =  this.selectNode.data.id
              }
          }

          let label={
              id:temp.id,
              name:temp.properties.name,
              type:temp.properties.type,
              visible:true,
              iconShow:false,
              isEditName:false,
              geoJson:{
                  points:points,
                  geo:temp,
              },
              children:[]
          }
          this.$axios({
              method:"post",
              url:"/authorApi/z-geo-file/addLabel",
              data:{
                  fileId:this.$store.state.currFolderId,
                  parentNodeId:parentNodeId,
                  labelNode:label,
              }
          }).then((res)=>{
              if(res.data.status ===200){
                  succMethod(res.data.data)
              }else{
                  failedMethod(res.data.message)
              }
          }).catch(()=>{
              failedMethod()
          })


      },
      //画点
      addMarker(){
        this.getGeneratorId(this.addMarker1)
      },
      addMarker1(id){
            //清空卡片
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          this.isDraw = true;
          this.jsonTemp = {
              type:'Feature',
              id: id,
              geometry: {
                  type: 'Point',
                  coordinates: []
              },
              properties: {
                  "id":id,
                  "type":'point',
                  "name":"点位标记",
                  "code": '&#xe6b6;',
                  "color": '#2A82E4',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":0.6,
                  "len":0,
                  "width":1,
                  "area":0,
                  "lineColor":'',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
          }
          //单击实现
          this.map.on('click',this.markerClickEvent)
          document.addEventListener('keyup', this.keyupEvent)
      },
      markerClickEvent(e){
          if(this.isDraw){
              this.$store.state.markerIndex = this.$store.state.markerIndex+1
              this.jsonTemp.properties.name = "点位标记"+this.$store.state.markerIndex
              this.jsonTemp.geometry.coordinates = [e.lngLat.lng, e.lngLat.lat]
              this.addLabel(this.jsonTemp,[],this.handleMarker,this.handleMarkerFailed)
          }
      },
      handleMarker(data){
          this.$store.state.handleNodeOption = "add"
          this.markerList.features.push(data.geoJson.geo)
          this.selectItems.geo = data.geoJson.geo
          this.editSelectItems.geo = data.geoJson.geo
          this.propertiesEditCardShow = true
          //地图渲染
          this.map.getSource('markerLayer').setData(this.markerList)
          //左侧数据列表新增
          this.labelPushInFolder(data)
          //联动函数
          this.mapMarkerStatus(this.jsonTemp.id,this.jsonTemp.properties.size)
          this.finishMarkerDraw()
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
      },
      handleMarkerFailed(message){
          //下标恢复
          this.$store.state.handleNodeOption = ""//添加
          this.$store.state.markerIndex = this.$store.state.markerIndex-1
          this.finishMarkerDraw()
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      finishMarkerDraw(){
        this.map.off('click',this.markerClickEvent)
      },
      //画线
      addLine(){
          this.getGeneratorId(this.addLine1)
      },
      addLine1(id){
          //清空卡片
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //定义数据
          this.isDraw = true;
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonTemp =  {
              "type": "Feature",
              "id": id,
              "properties": {
                  "id":id,
                  "type":'lineString',
                  "name":"",
                  "code": '',
                  "color": '#2A82E4',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,
                  "width":5,
                  "area":0,
                  "lineColor":'',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
              "geometry": {
                  "coordinates": [],
                  "type": "LineString"
              }
          }
          //添加图层
          let source = this.map.getSource('points');
          let lineMoveSource =this.map.getSource('line-move');
          let lineSource = this.map.getSource('line');
          if(source) {
              this.map.getSource('points').setData(this.jsonPoint);
              if (lineMoveSource) {
                  this.map.getSource('line-move').setData(this.jsonLine);
              }
              if (lineSource) {
                  this.map.getSource('line').setData(this.jsonLine);
              }
          }else{
              //添加图层
              this.map.addSource('points', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addSource('line', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('line-move', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addLayer({
                  id: 'line-move',
                  type: 'line',
                  source: 'line-move',
                  paint: {
                      'line-color': '#2A82E4',
                      'line-width': 3,
                      'line-opacity': 1,
                      'line-dasharray': [3, 1]
                  }
              });
              this.map.addLayer({
                  id: 'line',
                  type: 'line',
                  source: 'line',
                  paint: {
                      'line-color': '#2A82E4',
                      'line-width': 2,
                      'line-opacity': 1
                  }
              });
              this.map.addLayer({
                  id: 'points',
                  type: 'circle',
                  source: 'points',
                  paint: {
                      'circle-color': '#2A82E4',
                      'circle-radius': 5,
                      'circle-stroke-width': 3,
                      'circle-stroke-color': '#ffffff'
                  }
              });
          }

          //单击
          this.map.on('click',this.lineClickEvent)
          //鼠标滑动
          this.map.on('mousemove',this.lineMouseMoveEvent)
          //双击结束
          this.map.on('dblclick',this.lineDblclickEvent)
          //右键结束
          this.map.on('contextmenu',this.lineContextMenuEvent)
          //监听
          document.addEventListener('keyup', this.keyupEvent)
      },
      lineClickEvent(e){
          if(this.isDraw){
              let coords = [e.lngLat.lng, e.lngLat.lat]
              if(this.jsonPoint.features.length > 0) {
                  let prev = this.jsonPoint.features[this.jsonPoint.features.length - 1];
                  this.jsonLine.features.push({
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: [prev.geometry.coordinates, coords]
                      }
                  });
                  //加载地图的点
                  this.map.getSource('line').setData(this.jsonLine);
                  if(prev.geometry.coordinates[0] !==coords[0] && prev.geometry.coordinates[1] !==coords[1]){
                      this.jsonPoint.features.push({
                          type: 'Feature',
                          geometry: {
                              type: 'Point',
                              coordinates: coords
                          },
                          id: this.jsonTemp.id,
                          properties: {
                              "type":'point',
                              "name":"点位"+(this.jsonPoint.features.length+1),
                              "visible":"visible",
                              "country":"",
                              "addrName":"",
                              "imageList":[],
                              "color":'#2A82E4',
                              "secondId":this.jsonPoint.features.length+1
                          },
                      });
                      //在线里面添加点
                      this.jsonTemp.geometry.coordinates.push(coords)
                      this.map.getSource('points').setData(this.jsonPoint);
                  }
              }else{
                  this.jsonPoint.features.push({
                      type: 'Feature',
                      geometry: {
                          type: 'Point',
                          coordinates: coords
                      },
                      id: this.jsonTemp.id,
                      properties: {
                          "type":'point',
                          "name":"点位"+(this.jsonPoint.features.length+1),
                          "visible":"visible",
                          "country":"",
                          "addrName":"",
                          "imageList":[],
                          "color":'#2A82E4',
                          "secondId":this.jsonPoint.features.length+1
                      },
                  });
                  //添加名字的点

                  //在线里面添加点
                  this.jsonTemp.geometry.coordinates.push(coords)
                  this.map.getSource('points').setData(this.jsonPoint);
              }
          }
      },
      lineMouseMoveEvent(e){
          if(this.isDraw){
              let coords = [e.lngLat.lng, e.lngLat.lat];
              if (this.jsonPoint.features.length > 0) {
                  let prev = this.jsonPoint.features[this.jsonPoint.features.length - 1];
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: [prev.geometry.coordinates, coords]
                      }
                  };
                  this.map.getSource('line-move').setData(json);
              }
          }
      },
      lineDblclickEvent(){
          if(this.jsonPoint.features.length>0){
              if(this.isDraw) {
                  this.lineDataT()
              }
          }
      },
      /*
      * 王雪松写的程序
      * 你会在浏览器里面发现
      * 我爱你王悦
      * */
      lineContextMenuEvent(){
          if(this.jsonPoint.features.length > 1){
              if(this.isDraw){
                  this.map.getSource('points').setData(this.jsonPoint);
                  this.map.getSource('line-move').setData({
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: []
                      }
                  })
                  this.lineDataT()
              }
          }
      },
      lineDataT(){
          this.$store.state.lineIndex = this.$store.state.lineIndex+1
          this.jsonTemp.properties.name ="直线标记"+this.$store.state.lineIndex
          let line = turf.lineString(this.jsonTemp.geometry.coordinates)
          let lineLen = turf.length(line,{units: 'kilometers'})
          this.jsonTemp.properties.len = lineLen*1000
          this.addLabel(this.jsonTemp,this.jsonPoint.features,this.handleLine,this.handleLineFailed)
      },

      handleLine(data){
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          this.$store.state.handleNodeOption = "add"//添加
          this.lineJson.lineGeo.features.push(data.geoJson.geo)
          this.lineJson.lineNamePoint.features.push(
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: data.geoJson.points[0].geometry.coordinates
                  },
                  id: data.geoJson.geo.id,
                  properties: {
                      "type":'point',
                      "name": data.geoJson.geo.properties.name,
                      "visible":"visible",
                      "country":"",
                      "addrName":"",
                      "imageList":[],
                      "color":'#2A82E4',
                      "secondId":'',
                  },
              }
          )
          this.lineJson.linePoint.features.push(...data.geoJson.points)
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
          this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
          //赋值，打开卡片
         // this.selectItems.geo = this.deepClone(this.jsonTemp)
          this.selectItems.geo = data.geoJson.geo
          this.selectItems.points.push(...data.geoJson.points)

          this.editSelectItems.geo = data.geoJson.geo
          this.editSelectItems.points.push(...data.geoJson.points)

          this.propertiesEditCardShow = true
          //数据加入数组
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          //清空图层
          this.clearLayerAndSource()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          //结束划线
          this.finishLineDraw()
      },
      handleLineFailed(message){
          this.$store.state.handleNodeOption = ''
          this.$store.state.lineIndex = this.$store.state.lineIndex-1
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          //清空图层
          this.clearLayerAndSource()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          //结束划线
          this.finishLineDraw()
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      finishLineDraw(){
        this.map.off('click',this.lineClickEvent)
          this.map.off('mousemove',this.lineMouseMoveEvent)
          //双击结束
          this.map.off('dblclick',this.lineDblclickEvent)
          //右键结束
          this.map.off('contextmenu',this.lineContextMenuEvent)
      },

      //路线规划
      addRoad(){
          this.getGeneratorId(this.addRoad1)
      },
      addRoad1(id){
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //定义数据
          this.isDraw = true;
          this.jsonPoint.features=[]
          this.jsonLine.features = []
          this.jsonTemp = {
              "type": "Feature",
              "id": id,
              "properties": {
                  "id":id,
                  "type":'roadString',
                  "name":"",
                  "code": '',
                  "color": '#FF8D1A',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,
                  "width":5,
                  "area":0,
                  "lineColor":'',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
              "geometry": {
                  "coordinates": [],
                  "type": "LineString"
              }
          }
          this.pointArray = []
          this.roadClickLength =0
          //添加图层
          let source = this.map.getSource('road-points');
          let lineMoveSource =this.map.getSource('road-line-move');
          let lineSource = this.map.getSource('road-line');
          if(source) {
              this.map.getSource('road-points').setData(this.jsonPoint);
              if (lineMoveSource) {
                  this.map.getSource('road-line-move').setData(this.jsonLine);
              }
              if (lineSource) {
                  this.map.getSource('road-line').setData(this.jsonLine);
              }
          }else{
              //添加图层
              this.map.addSource('road-points', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addSource('road-line-move', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('road-line', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addLayer({
                  id: 'road-line-move',
                  type: 'line',
                  source: 'road-line-move',
                  paint: {
                      'line-color': '#FF8D1A',
                      'line-width': 3,
                      'line-opacity': 1,
                      'line-dasharray': [3, 1]
                  }
              });
              this.map.addLayer({
                  id: 'road-line',
                  type: 'line',
                  source: 'road-line',
                  paint: {
                      'line-color': '#FF8D1A',
                      'line-width': 3,
                      'line-opacity': 1
                  }
              });
              this.map.addLayer({
                  id: 'road-points',
                  type: 'circle',
                  source: 'road-points',
                  paint: {
                      'circle-color': '#FF8D1A',
                      'circle-radius': 5,
                      'circle-stroke-width': 3,
                      'circle-stroke-color': '#ffffff'
                  }
              });
          }
          this.map.on('click',this.roadClickEvent)
          this.map.on('mousemove',this.roadMousemoveEvent)
          this.map.on('dblclick',this.roadDblclickEvent)
          this.map.on("contextmenu",this.roadContextmenuEvent)
          document.addEventListener('keyup', this.keyupEvent)
      },
      async roadClickEvent(e) {
          if (this.isDraw) {
              // this.flag = false
              let coords = [e.lngLat.lng, e.lngLat.lat]
              if (this.jsonPoint.features.length > 0) {
                  let temp = this.pointArray.concat([coords])
                   this.roadClickLength = this.roadLength(temp)
                  if (this.roadClickLength > 100) {
                      this.$store.state.snackbarShow = true
                      this.$store.state.snackbarText = "距离过远，暂无可规划路线"
                      this.$store.state.snackbarType = 'error'
                      this.flag = false
                  } else {
                      if (this.pointArray[this.pointArray.length - 1][0] !== coords[0] && this.pointArray[this.pointArray.length - 1][1] !== coords[1]) {
                          this.flag = false
                          this.pointArray.push(coords)
                          let pre = this.pointArray[this.pointArray.length - 2]
                          let response = await this.getRoad(pre, coords)
                          if(response.data.status === 200){
                              this.jsonTemp.geometry.coordinates = this.jsonTemp.geometry.coordinates.concat(response.data.data)
                              this.jsonPoint.features.push({
                                  type: 'Feature',
                                  geometry: {
                                      type: 'Point',
                                      coordinates: coords
                                  },
                                  id:this.jsonTemp.id,
                                  properties: {
                                      "type": 'point',
                                      "name": "点位" + (this.jsonPoint.features.length + 1),
                                      "visible": "visible",
                                      "country": "",
                                      "addrName": "",
                                      "imageList": [],
                                      "color":'#FF8D1A',
                                      "secondId": this.jsonPoint.features.length + 1
                                  },
                              })
                              this.jsonLine.features.push({
                                  "type": "Feature",
                                  "geometry": {
                                      "coordinates": response.data.data,
                                      "type": "LineString"
                                  }
                              })
                              this.flag =true
                              if (this.map.getSource('road-points')) {
                                  this.map.getSource('road-points').setData(this.jsonPoint);
                              }
                              if (this.map.getSource('road-line')) {
                                  this.map.getSource('road-line').setData(this.jsonLine);
                              }

                          }else if(response.data.status === 305){
                              if (this.jsonPoint.features.length === 1) {
                                  this.jsonPoint.features = []
                                  this.pointArray = []
                                  this.map.getSource('road-points').setData(this.jsonPoint);
                                  let json = {
                                      type: 'Feature',
                                      geometry: {
                                          type: 'LineString',
                                          coordinates: []
                                      }
                                  };
                                  this.map.getSource('road-line-move').setData(json);
                              }
                              this.flag = true
                              this.$store.state.snackbarShow = true
                              this.$store.state.snackbarText = "暂无可规划路线"
                              this.$store.state.snackbarType = 'error'
                          }
                      }else{
                         // console.log("点击了相同点")
                      }
                  }
              } else {
                  this.jsonPoint.features.push({
                      type: 'Feature',
                      geometry: {
                          type: 'Point',
                          coordinates: coords
                      },
                      id:this.jsonTemp.id,
                      properties: {
                          "type": 'point',
                          "name": "点位" + (this.jsonPoint.features.length + 1),
                          "visible": "visible",
                          "country": "",
                          "addrName": "",
                          "imageList": [],
                          "color":'#FF8D1A',
                          "secondId": this.jsonPoint.features.length + 1
                      },
                  })
                  this.map.getSource('road-points').setData(this.jsonPoint);
                  this.pointArray.push(coords)
              }
          }
      },
      roadMousemoveEvent(e){
          if(this.isDraw){
              let coords = [e.lngLat.lng, e.lngLat.lat];
              if (this.jsonPoint.features.length > 0) {
                  let prev = this.jsonPoint.features[this.jsonPoint.features.length - 1];
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: [prev.geometry.coordinates, coords]
                      }
                  };
                  this.map.getSource('road-line-move').setData(json);
              }
          }
      },
      roadDblclickEvent(){
          if(this.isDraw){
              if(this.jsonPoint.features.length > 0 && this.roadClickLength <=100){
                  let temp = setInterval(()=> {
                      if(this.flag){
                          this.roadDataT()
                          this.flag = false
                          clearInterval(temp)
                      }
                  }, 50);
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: []
                      }
                  };
                  this.map.getSource('road-line-move').setData(json);

              }
          }
      },
      roadContextmenuEvent(){
          if(this.isDraw){
              if(this.jsonPoint.features.length > 1){
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: []
                      }
                  };
                  this.map.getSource('road-line-move').setData(json);
                  this.roadDataT()
              }
          }
      },
       roadDataT(){
           let line = turf.lineString(this.jsonTemp.geometry.coordinates)
           let length = turf.length(line, {units: 'kilometers'});
           this.jsonTemp.properties.len = length*1000
           this.addLabel(this.jsonTemp,this.jsonPoint.features,this.handleRoad,this.handleRoadFailed)
      },
      handleRoad(data){
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          this.$store.state.handleNodeOption = "add"//添加
          this.roadJson.roadGeo.features.push(data.geoJson.geo)
          this.roadJson.roadPoint.features.push(...data.geoJson.points)
          this.roadJson.roadNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: data.geoJson.points[0].geometry.coordinates
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":data.geoJson.geo.properties.name,
                  "visible":"visible",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "color":'#FF8D1A',
                  "secondId":''
              },
          })
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
          this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
          //
          this.selectItems.geo = data.geoJson.geo
          this.selectItems.points.push(...data.geoJson.points)

          this.editSelectItems.geo = data.geoJson.geo
          this.editSelectItems.points.push(...data.geoJson.points)

          this.propertiesEditCardShow = true
          //数据加入数组
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
          //清理图层
          this.clearLayerAndSource()
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          //结束划线
          this.finishRoadDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      handleRoadFailed(message){
          this.isDraw = false;
          this.$store.state.handleNodeOption = ""//
          this.clearLayerAndSource()
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          //结束划线
          this.finishRoadDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      async getRoad(pre,coords){
          let data= new FormData()
          data.append('oriLon',pre[0])
          data.append('oriLat',pre[1])
          data.append('desLon',coords[0])
          data.append('desLat',coords[1])
          return this.$axios.post('/authorApi/POI/getDirectionlite',data)
      },
      finishRoadDraw(){
          this.map.off('click',this.roadClickEvent)
          this.map.off('mousemove',this.roadMousemoveEvent)
          this.map.off('dblclick',this.roadDblclickEvent)
          this.map.off("contextmenu",this.roadContextmenuEvent)

      },
      //判断线段长度
      roadLength(temp){
        let line = turf.lineString(temp)
          return turf.length(line, {units: 'kilometers'})
      },
      //画圆
      addCircle(){
          this.getGeneratorId(this.addCircle1)
      },
      addCircle1(id){
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //清空图层
          this.clearLayerAndSource()
          //定义变量
          this.isDraw = true;
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonTemp = {
              "type": "Feature",
              "id": id,
              "properties": {
                  "id":id,
                  "type":'circle',
                  "name":"",
                  "code": '',
                  "color": '#2A82E4',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,
                  "width":4,
                  "area":0,
                  "lineColor":'#2A82E4',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
              "geometry": {
                  "coordinates": [],
                  "type": "Polygon"
              }
          }
          this.isMousemove=false;
          this.pointArray = []
          this.pointCoord=[]
          //加载图层
          let source = this.map.getSource('circle');
          if (source) {
              this.map.getSource('circle').setData(this.jsonLine);
          }else{
              this.map.addSource('circle', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('circle-point', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addLayer({
                  "id": "circle-point",
                  "type": "circle",
                  "source": "circle-point",
                  "paint": {
                      "circle-radius": 2,
                      "circle-color":'#ffffff',
                  },
              })
              this.map.addLayer({
                  "id": "circle-point-stroke",
                  "type": 'line',
                  source: 'circle',
                  paint: {
                      'line-color': '#2A82E4',
                      'line-width': 2,
                  }
              })
              this.map.addLayer({
                  "id": "circle",
                  "type": "fill",
                  "source": "circle",
                  "layout": {},
                  "paint": {
                      "fill-color": "#2A82E4",
                      "fill-opacity": 0.5,
                  }
              });
          }
          this.map.on('click',this.circleClickEvent)
          this.map.on("mousemove",this.circleMousemove)
          document.addEventListener('keyup', this.keyupEvent)
      },
      circleClickEvent(e){
          if(this.isDraw && this.isMousemove){
              this.isDraw = false;
              this.isMousemove = false
              if (this.pointArray.length !== 0) {
                  let _points = [this.pointArray[0], this.pointCoord];
                  let line = turf.lineString(_points);
                  let len = turf.length(line);//半径
                  if (len >= 0) {
                      let circle = this.createGeoJSONCircle(this.pointArray[0], len)
                      this.map.getSource('circle').setData(circle);
                      this.jsonTemp.geometry.coordinates = circle.geometry.coordinates
                      //this.jsonTemp.properties.len = len*1000
                      this.circleRadiusText = len*1000
                      this.circleRadiusCardTop = e.point.y -15+ "px"
                      this.circleRadiusCardLeft = e.point.x  + 5 + "px"
                      this.circleRadiusCardShow = true
                  }
                  //清除选择按钮
                  this.map.getCanvas().style.cursor = 'default'
                  document.getElementById("labelCanvas").style.cursor = 'default';
              }
          }else if(this.isDraw) {
              let coords = [e.lngLat.lng,e.lngLat.lat]
              this.pointArray.push(coords)
              // if(isFilst){
              //     filstCoords=[e.lngLat.lng,e.lngLat.lat];
              //     isFilst=false
              // }
              this.jsonPoint.features.push({
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: [e.lngLat.lng,e.lngLat.lat]
                  }
              });
              this.jsonTemp.properties.center = [e.lngLat.lng,e.lngLat.lat]
              this.map.getSource('circle-point').setData(this.jsonPoint)
              this.isMousemove = true;
          }
      },
      circleMousemove(e){
          if(this.isDraw){
              this.pointCoord = [e.lngLat.lng, e.lngLat.lat];
              if(this.pointArray.length !==0){
                  let _points = [this.pointArray[0],this.pointCoord];
                  let line = turf.lineString(_points);
                  let len = turf.length(line);
                  if(len>=0){
                      let geo = turf.circle(this.pointArray[0],len)
                      this.map.getSource('circle').setData(geo)
                  }
              }
          }
      },
      finishCircleDraw(){
          this.map.off('click',this.circleClickEvent)
          this.map.off('mousemove',this.circleMousemove)
          this.circleRadiusCardShow = false
          this.circleRadiusCardLeft = ''
          this.circleRadiusCardTop = ''
          this.circleRadiusText = ''

      },
      createGeoJSONCircle(center,radiusInKm,){
          let steps = 0
          if(radiusInKm < 10)
              steps = 64
          else
              steps = Math.floor(radiusInKm) * 10
          let options={
              steps: steps, //分割数量 数量越多圆越精细 默认值：64（如果圆比较大推荐类似 Math.floor(radius) * 10 这样根据半径可变的切割）
              units: "kilometers",
          }
          return turf.circle(center, radiusInKm, options)

      },
      cancelCircleRadius(){
          this.finishCircleDraw()
          this.clearLayerAndSource()
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
      },
      sureCircleRadius(){
          if(this.circleRadiusText <=0){
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "请输入正确的半径数值"
              this.$store.state.snackbarType = 'error'
          }else if(this.circleRadiusText  >= 10000000){
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "半径数值过大，无法添加显示"
              this.$store.state.snackbarType = 'error'
          }else{
              this.circleT()
          }
      },
      //原型的数据处理
      circleT(){
          this.jsonPoint.features = []
          let circleRadius = Number(this.circleRadiusText)
          this.jsonTemp.properties.len = circleRadius
          let len = circleRadius/1000
          let tempCircle = this.createGeoJSONCircle(this.jsonTemp.properties.center,len)
          this.jsonTemp.geometry.coordinates = tempCircle.geometry.coordinates
          this.jsonTemp.properties.area = turf.area(turf.polygon(tempCircle.geometry.coordinates))
          this.addLabel(this.jsonTemp,this.jsonPoint.features,this.handleCircle,this.handleCircleFailed)
      },
      handleCircle(data){
          this.$store.state.handleNodeOption = "add"//添加
          //名字节点
          this.polygonJson.polygonNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: data.geoJson.geo.properties.center
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":data.geoJson.geo.properties.name,
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "color":'#2A82E4',
                  "secondId":'',
              },
          })
          let point = {
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: data.geoJson.geo.properties.center
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":"半径："+this.lengthUomConversion(data.geoJson.geo.properties.len),
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "color":'#2A82E4',
                  "secondId":'',
              },
          }
          let translation = turf.transformTranslate(point,data.geoJson.geo.properties.len/1000,90)
          this.polygonJson.circleRadiusPoint.features.push(translation)
          this.polygonJson.polygonGeo.features.push(data.geoJson.geo)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);

          this.selectItems.geo = data.geoJson.geo
          this.editSelectItems.geo = data.geoJson.geo

          this.propertiesEditCardShow = true
          this.cancelCircleRadius()
          //数据加入数组
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      handleCircleFailed(message){
          this.$store.state.handleNodeOption = ''
          this.cancelCircleRadius()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      //画矩形
      addRectangle(){
          this.getGeneratorId(this.addRectangle1)
      },
      addRectangle1(id){
          //清空卡片
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //清空图层
          this.clearLayerAndSource()
          //定义变量
          this.isDraw = true
          this.pointArray = []
          this.pointCoord=[]
          this.isMousemove=false;
          this.jsonPoint.features = []
          this.jsonTemp = {
              "type": "Feature",
              "id": id,
              "properties": {
                  "id":id,
                  "type":'rectangle',
                  "name":"",
                  "code": '',
                  "color": '#02DECF',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,//长度或者周长
                  "width":4,
                  "area":0,
                  "lineColor":'#02DECF',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
              "geometry": {
                  "coordinates": [],
                  "type": "Polygon"
              }
          }
          //加载图层
          let source = this.map.getSource('rectangle');
          if(source) {
              this.map.getSource('rectangle').setData(this.jsonPoint);
          }else{
              this.map.addSource('rectangle', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addLayer({
                  "id": "rectangle",
                  "type": "fill",
                  "source": "rectangle",
                  "layout": {},
                  "paint": {
                      "fill-color":"#02DECF",
                      "fill-opacity": 0.5
                  }
              });
          }

          this.map.on("click",this.rectangleClickEvent)
          this.map.on("mousemove",this.rectangleMousemove)
          document.addEventListener('keyup', this.keyupEvent)
      },
      rectangleClickEvent(e){
          if(this.isDraw){
              if(this.jsonPoint.features.length !== 0 && this.pointCoord[0] !== e.lngLat.lng && this.pointCoord[0] !== e.lngLat.lat){
                  this.isMousemove=false;
                  this.isDraw=false;
                  this.map.getCanvas().style.cursor = 'default';
                  document.getElementById("labelCanvas").style.cursor = 'default';
                  this.jsonTemp.geometry.coordinates[0].push(this.jsonTemp.geometry.coordinates[0][0])
                  this.rectangleT()
              }else{
                  this.pointCoord = [e.lngLat.lng, e.lngLat.lat]
                  this.isMousemove = true
              }
          }
      },
      rectangleMousemove(e){
          if(this.isDraw && this.isMousemove){
             let  moveCoords = [e.lngLat.lng, e.lngLat.lat]
              let rightTopCoords=[];
              rightTopCoords=[moveCoords[0],this.pointCoord[1]];
              let buttomLeftCoords=[];
              buttomLeftCoords=[this.pointCoord[0],moveCoords[1]];
              let coords=[];
              coords=[this.pointCoord,rightTopCoords,moveCoords,buttomLeftCoords]
              this.jsonPoint.features=[];
              this.jsonPoint.features.push({
                  type: 'Feature',
                  geometry: {
                      type: 'Polygon',
                      coordinates: [coords]
                  }
              });
              this.jsonTemp.geometry.coordinates = [coords]//赋值
              this.map.getSource('rectangle').setData(this.jsonPoint);
          }
      },
      //矩形的数据处理
      async rectangleT(){
          //计算面积
          let areaArray =turf.polygon(this.jsonTemp.geometry.coordinates)
          this.jsonTemp.properties.area = turf.area(areaArray)//平方米
          //计算长度
          let lenArray = turf.lineString(this.jsonTemp.geometry.coordinates[0])
          let len = turf.length(lenArray,{units:'kilometers'})
          this.jsonTemp.properties.len = len*1000
          //中心点
          let center =turf.centroid(areaArray)
          this.jsonTemp.properties.center = center.geometry.coordinates
          //取点
          let point ={
              'type': 'FeatureCollection',
              'features': []
          }
          let pointArray = this.deepClone(this.jsonTemp.geometry.coordinates[0])
          pointArray.pop()
          pointArray.forEach((item,index)=>{
              let temp = {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: item
                  },
                  "id": this.jsonTemp.id,
                  properties: {
                      "type":'point',
                      "name":"点位"+(index+1),
                      "visible":"visible",
                      "country":'',
                      "addrName":'',
                      "imageList":[],
                      "color":'#02DECF',
                      "secondId":index+1
                  },
              }
              point.features.push(temp)
          })
          this.addLabel(this.jsonTemp,point.features,this.handleRectangle,this.handleRectangleFailed)
      },
      handleRectangle(data){
          this.$store.state.handleNodeOption = "add"//添加
          //四个点加入
          this.selectItems.points.push(...data.geoJson.points)
          this.editSelectItems.points.push(...data.geoJson.points)

          this.polygonJson.polygonPoint.features.push(...data.geoJson.points)
          //中心点，Name
          this.polygonJson.polygonNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: data.geoJson.geo.properties.center
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":data.geoJson.geo.properties.name,
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "color":'#02DECF',
                  "imageList":[],
                  "secondId":'',
              },
          })
          //在地图上画name点
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          //获取两个线段中心点
          let leftCenter = turf.midpoint(turf.point(data.geoJson.geo.geometry.coordinates[0][0]),turf.point(data.geoJson.geo.geometry.coordinates[0][3]))
          let leftLen = turf.distance(turf.point(data.geoJson.geo.geometry.coordinates[0][0]),turf.point(data.geoJson.geo.geometry.coordinates[0][3]),{units:'kilometers'})
          this.polygonJson.polygonLenPoint.features.push(
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: leftCenter.geometry.coordinates
                  },
                  id: data.geoJson.geo.id,
                  properties: {
                      "type":'point',
                      "name":this.lengthUomConversion(leftLen*1000),
                      "visible":"visible",
                      "country":'',
                      "addrName":'',
                      "color":'#02DECF',
                      "imageList":[],
                      "secondId":''
                  },
              }
          )
          let rightCenter = turf.midpoint(turf.point(data.geoJson.geo.geometry.coordinates[0][2]),turf.point(data.geoJson.geo.geometry.coordinates[0][3]))
          let rightLen = turf.distance(turf.point(data.geoJson.geo.geometry.coordinates[0][2]),turf.point(data.geoJson.geo.geometry.coordinates[0][3]),{units:'kilometers'})
          this.polygonJson.polygonLenPoint.features.push(
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: rightCenter.geometry.coordinates
                  },
                  id: data.geoJson.geo.id,
                  properties: {
                      "type":'point',
                      "name":this.lengthUomConversion(rightLen*1000),
                      "visible":"visible",
                      "country":'',
                      "addrName":'',
                      "color":'#02DECF',
                      "imageList":[],
                      "secondId":''
                  },
              }
          )
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          this.polygonJson.polygonGeo.features.push(data.geoJson.geo)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);

          this.selectItems.geo = data.geoJson.geo
          this.editSelectItems.geo = data.geoJson.geo
          this.propertiesEditCardShow = true

          //数据加入数组
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
          //清楚图层
          this.clearLayerAndSource()
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.finishRectangleDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      handleRectangleFailed(message){
          this.$store.state.handleNodeOption = ""//添加
          //清楚图层
          this.clearLayerAndSource()
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.finishRectangleDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      finishRectangleDraw(){
          this.map.off('click',this.rectangleClickEvent)
          this.map.off("mousemove",this.rectangleMousemove)
      },
      //画多边形
      addPolygon(){
          this.getGeneratorId(this.addPolygon1)
      },
      addPolygon1(id){
          //清空卡片
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //清空图层
          this.clearLayerAndSource()
          //定义变量
          this.isDraw = true;

          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonTemp = {
              "type": "Feature",
              "geometry": {
                  "coordinates": [],
                  "type": "MultiPolygon"
              },
              "id":id,
              "properties": {
                  "id":id,
                  "type":'polygon',
                  "name":"图形标记"+this.$store.state.polygonIndex,
                  "code": '',
                  "color": '#02DECF',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,//长度或者周长
                  "width":4,
                  "area":0,
                  "lineColor":'#02DECF',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
          }
          this.pointArray = [];
          this.pointCoord = [];
          this.polygonFeatureCollection={
              type:"FeatureCollection",
              features:[]
          }
          //加载图层
          let source = this.map.getSource('points-area');
          if(source) {
              this.map.getSource('points-area').setData(this.jsonPoint);
              this.map.getSource('line-area').setData(this.jsonLine);
              this.map.getSource('line-area-move').setData(this.jsonLine)
          }else{
              this.map.addSource('points-area', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addSource('line-area', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('line-area-move', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addLayer({
                  id: 'line-area',
                  type: 'fill',
                  source: 'line-area',
                  paint: {
                      'fill-color': '#02DECF',
                      'fill-opacity': 0.5
                  }
              });
              this.map.addLayer({
                  id: 'line-area-stroke',
                  type: 'line',
                  source: 'line-area',
                  paint: {
                      'line-color': '#02DECF',
                      'line-width': 4,
                  }
              });
              this.map.addLayer({
                  id: 'line-area-move',
                  type: 'line',
                  source: 'line-area-move',
                  paint: {
                      'line-color': '#02DECF',
                      'line-width': 4,
                  }
              });
              this.map.addLayer({
                  id: 'points-area',
                  type: 'circle',
                  source: 'points-area',
                  paint: {
                      'circle-color': '#02DECF',
                      'circle-radius': 5,
                      'circle-stroke-width': 3,
                      'circle-stroke-color': '#ffffff'
                  }
              });
          }

          this.map.on('click',this.polygonClickEvent)
          this.map.on("mousemove",this.polygonMousemoveEvent)
          this.map.on('contextmenu',this.polygonContextmenuEvent)
          //监听
          document.addEventListener('keyup', this.keyupEvent)
      },
      polygonClickEvent(e){
          if(this.isDraw){
              let coords=[e.lngLat.lng, e.lngLat.lat]
              this.pointArray.push(coords)
              if(coords[0] === this.pointCoord[0] && coords[1] === this.pointCoord[1]){
                  this.isDraw = false
                  this.polygonT()
              }else{
                  //添加点
                  this.pointCoord = coords
                  this.jsonPoint.features.push({
                      type: 'Feature',
                      geometry: {
                          type: 'Point',
                          coordinates: coords
                      },
                      "id": this.jsonTemp.id,
                      properties: {
                          "type":'point',
                          "name":"点位"+(this.jsonPoint.features.length+1),
                          "visible":"visible",
                          "country":"",
                          "addrName":"",
                          "imageList":[],
                          "color":'#02DECF',
                          "secondId":this.jsonPoint.features.length+1
                      },

                  });
                  this.map.getSource('points-area').setData(this.jsonPoint);
              }
          }
      },
      polygonMousemoveEvent(e){
          if(this.isDraw){
              let coords = [e.lngLat.lng, e.lngLat.lat];
              let len = this.jsonPoint.features.length;
              if(len >1){
                  let pts = this.pointArray.concat([coords]);
                  pts = pts.concat([this.pointArray[0]])
                  let poly = turf.polygon([pts])
                  let json = turf.unkinkPolygon(poly)
                  this.polygonFeatureCollection.features = json.features
                  this.map.getSource('line-area').setData(this.polygonFeatureCollection);
              }else if(len> 0){
                  let pev = this.pointArray[0]
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: [pev, coords]
                      }
                  };
                  this.map.getSource('line-area-move').setData(json);
              }
          }
      },
      polygonContextmenuEvent(){
          if(this.isDraw){
              if(this.jsonPoint.features.length >2){
                  //测量结束
                  this.isDraw = false;
                  let pts =  this.pointArray
                  pts = pts.concat([this.pointArray[0]])
                  //this.jsonTemp.geometry.coordinates = [pts]
                  let poly = turf.polygon([pts])
                  let json = turf.unkinkPolygon(poly)
                  this.polygonFeatureCollection.features = json.features
                  this.map.getSource('line-area').setData(this.polygonFeatureCollection);
                  //计算面积和周长
                  this.polygonT()
              }
          }
      },
      async polygonT(){
          this.jsonTemp.properties.area = turf.area(this.polygonFeatureCollection)
          for(let i = 0 ;i<this.polygonFeatureCollection.features.length;i++){
              this.jsonTemp.geometry.coordinates.push(this.polygonFeatureCollection.features[i].geometry.coordinates)
          }
          let lineArray = this.jsonPoint.features.concat(this.jsonPoint.features[0])
          let len =turf.length(turf.lineString(lineArray),{units:'kilometers'})
          this.jsonTemp.properties.len = len*1000

          //中心点
          let center =turf.centroid(this.polygonFeatureCollection)
          this.jsonTemp.properties.center = center.geometry.coordinates

          this.addLabel(this.jsonTemp, this.jsonPoint.features, this.handlePolygon, this.handlePolygonFailed)



      },
      handlePolygon(data){
          this.$store.state.handleNodeOption = "add"//添加
          this.selectItems.points.push(...data.geoJson.points)
          this.editSelectItems.points.push(...data.geoJson.points)
          this.polygonJson.polygonPoint.features.push(...data.geoJson.points)

          this.polygonJson.polygonNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: data.geoJson.geo.properties.center
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":data.geoJson.geo.properties.name,
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "color":'#02DECF',
                  "imageList":[],
                  "secondId":''
              },
          })
          this.polygonJson.polygonGeo.features.push(data.geoJson.geo)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          //赋值
          this.selectItems.geo = data.geoJson.geo
          this.editSelectItems.geo = data.geoJson.geo

          this.propertiesEditCardShow = true
          //数据加入数组
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.map.getCanvas().style.cursor = 'default'
          document.getElementById("labelCanvas").style.cursor = 'default';
          //清除图层
          this.clearLayerAndSource()
          //结束划线
          this.finishPolygonDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      handlePolygonFailed(message){
          this.$store.state.handleNodeOption = ""
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.map.getCanvas().style.cursor = 'default'
          document.getElementById("labelCanvas").style.cursor = 'default';
          //清除图层
          this.clearLayerAndSource()
          //结束划线
          this.finishPolygonDraw()
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      finishPolygonDraw(){
          this.map.off('click',this.polygonClickEvent)
          this.map.off("mousemove",this.polygonMousemoveEvent)
          this.map.off('contextmenu',this.polygonContextmenuEvent)
      },
      //画行政区域
      addAdministrativeArea(){
          this.getGeneratorId(this.addAdministrativeArea1)
      },
      addAdministrativeArea1(id){
          this.closeEditCard()
          this.cleanMapOnEvent()
          this.map.doubleClickZoom.disable();
          //清空图层
          this.clearLayerAndSource()
          this.hideLayer('none')
          this.popup = new mapboxgl.Popup({
              closeButton: false
          });
          //定义数据
          this.jsonTemp={
              "type": "Feature",
              "geometry": {
                  "coordinates": [],
                  "type": "MultiPolygon"
              },
              "id":id,
              "properties": {
                  "id":id,
                  "type":'administrativeArea',
                  "name":"",
                  "code": '',
                  "color": '#FFC300',
                  "remark": "",
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "size":1,
                  "len":0,//长度或者周长
                  "width":2,
                  "area":0,
                  "lineColor":'#2A82E4',
                  "center":[],
                  "graphArea":'',
                  "userId":'',
                  'nickName':'',
              },
          }
          this.currentBoundary = this.boundaryArray[0]
          this.currentChildrenList = this.boundaryChildrenArray[0]
          this.canClick = true
          //数组恢复初始状态
          this.boundaryArray = this.boundaryArray.splice(0,1)
          this.boundaryChildrenArray = this.boundaryChildrenArray.splice(0,1)
          this.areaName = '-'
          this.areaCardShow = true
          //图层
          let source = this.map.getSource('area-boundary');
          let source1 = this.map.getSource('area-children-fill')
          if(source){
              this.map.getSource('area-boundary').setData(this.currentBoundary);
              if(source1)
                  this.map.getSource('area-children-fill').setData(this.currentChildrenList);
          }else{
              this.map.addSource('area-father',{
                  type: 'geojson',
                  data: this.boundaryArray[0]
              })
              this.map.addSource('area-boundary', {
                  type: 'geojson',
                  data: this.currentBoundary
              });
              this.map.addSource('area-children-fill', {
                  type: 'geojson',
                  data: this.currentChildrenList
              });
              this.map.addLayer({
                  id: 'area-father',
                  type: 'line',
                  source: 'area-father',
                  paint: {
                      'line-color': '#ff0000',
                      'line-width': 3,
                  }
              })
              this.map.addLayer({
                  id: 'area-father-fill',
                  type: 'fill',
                  source: 'area-father',
                  paint: {
                      'fill-color': '#2A82E4',
                      'fill-opacity': 0
                  }
              })
              this.map.addLayer({
                  id: 'area-boundary',
                  type: 'line',
                  source: 'area-boundary',
                  paint: {
                      'line-color': '#ffffff',
                      'line-width': 3,
                  }
              })
              this.map.addLayer({
                  id: 'area-children-fill',
                  type: 'fill',
                  source: 'area-children-fill',
                  paint: {
                      'fill-color': '#2A82E4',
                      'fill-opacity': [
                          'case',
                          ['boolean', ['feature-state', 'hover'], false],
                          1,
                          0
                      ]
                  }
              })
          }
          this.mapFitBoundary(this.currentBoundary)
          this.map.on('mousemove','area-children-fill',this.areaMousemoveEvent)
          this.map.on('mouseleave','area-children-fill',this.areaMouseleaveEvent)
          this.map.on('click','area-children-fill',this.areaClickEvent)
          this.map.on('click',this.areaFatherClickEvent)
          //监听
          document.addEventListener('keyup', this.keyupEvent)
      },
      areaMousemoveEvent(e){
          if(e.features.length >0){
              if (this.hoveredStateId !== null){
                  this.map.setFeatureState(
                      { source: 'area-children-fill', id: this.hoveredStateId },
                      {hover:false}
                  );
              }
              this.hoveredStateId = e.features[0].id;
              this.map.setFeatureState(
                  { source: 'area-children-fill', id: this.hoveredStateId },
                  { hover: true }
              );

              this.popup
                  .setLngLat(e.lngLat)
                  .setText(e.features[0].properties.name)
                  .addTo(this.map);
          }
      },
      areaMouseleaveEvent(){
          if (this.hoveredStateId !== null) {
              this.map.setFeatureState(
                  { source: 'area-children-fill', id: this.hoveredStateId },
                  { hover: false }
              );
          }
          this.hoveredStateId = null;
          this.popup.remove()
      },
      areaClickEvent(e){
          if(e.features.length >0){
              if(this.currentSelect === 0){
                  this.currentSelect = this.currentSelect +1
                  this.getCountryBoundary(e.features[0].id)
                  this.getChildrenList(e.features[0].id)
              }else{
                      if(e.features[0].properties.childrenNum>0){
                          this.getCountryBoundary(e.features[0].id)
                          this.getChildrenList(e.features[0].id)
                      }else{
                          if(this.canClick)
                              this.getCountryBoundary(e.features[0].id)
                      }
              }
          }
      },
      areaFatherClickEvent(e){
          if(this.boundaryArray.length>1){
              let isIn = this.pointIsInGeo([e.lngLat.lng,e.lngLat.lat],this.currentBoundary)
              if(!isIn){
                  this.canClick = true

                  this.boundaryArray.pop()
                  this.currentBoundary = this.boundaryArray[this.boundaryArray.length-1]
                  this.areaName = this.getAreaName(this.boundaryArray)
                  this.boundaryChildrenArray.pop()
                  this.currentChildrenList = this.boundaryChildrenArray[this.boundaryChildrenArray.length-1]
                  this.map.getSource('area-children-fill').setData(this.currentChildrenList);
                  this.map.getSource('area-boundary').setData(this.currentBoundary);
                  this.mapFitBoundary(this.currentBoundary)
              }
          }
      },
      mapFitBoundary(geo, type=''){
        const bbox = turf.bbox(geo)
        if (type === 'point') {
          this.map.flyTo({
            center: [geo['geometry']['coordinates'][0], geo['geometry']['coordinates'][1]],
            zoom: 15
          })
        } else {
          this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
            linear: false,
            animate: true,
            padding: {top: 0, bottom:0, left: 0, right: 0},
          })
        }
      },
      getAreaName(array){
          if(array.length > 1){
              let temp = ''
              for(let i = 1;i<array.length;i++){
                  temp = temp+'-'+array[i].properties.name
              }
              return temp.substring(1,temp.length)
          }else{
              return '-'
          }
      },
      pointIsInGeo(point,geo){
          let pt = turf.point(point)
          return turf.booleanPointInPolygon(pt,geo)
      },
      async getCountryBoundary(id){
          let data = new FormData()
          data.append("id",id)
          this.$axios.post('/authorApi/a-area-geo/getAreaGeoById',data).then((res)=>{
              if(res.data.status === 200){
                  this.boundaryArray.push(res.data.data.features[0])
                  this.currentBoundary = res.data.data.features[0]
                  if(this.currentSelect !== 0){
                      this.areaName = this.getAreaName(this.boundaryArray)
                      this.map.getSource('area-boundary').setData(this.currentBoundary);
                      this.mapFitBoundary(res.data.data)
                  }
                  if(res.data.data.features[0].properties.childrenNum === 0){
                      this.boundaryChildrenArray.push(res.data.data)
                      this.currentChildrenList =res.data.data
                      this.canClick = false
                      this.map.getSource('area-children-fill').setData(this.currentChildrenList);
                  }
              }
          })
      },
      async getChildrenList(id){
          let data = new FormData()
          data.append("id",id)
          return this.$axios.post('/authorApi/a-area-geo/getChildAreaGeoById',data).then((res)=>{
              if(res.data.status === 200){
                  this.boundaryChildrenArray.push(res.data.data)
                  this.currentChildrenList= res.data.data
                  if(this.currentSelect !== 0){
                      this.map.getSource('area-children-fill').setData(this.currentChildrenList);
                  }
              }
          })
      },
      //数据处理
      sureAreaFigure(){
          if(this.boundaryArray.length > 1){

              //赋值
              this.closeAreaCard()
              this.jsonTemp.geometry.coordinates = this.deepClone(this.currentBoundary.geometry.coordinates)
              this.jsonTemp.geometry.type = this.deepClone(this.currentBoundary.geometry.type)
              this.jsonTemp.properties.graphArea = this.deepClone(this.areaName)
              this.jsonTemp.properties.center = this.deepClone(this.currentBoundary.properties.center)

              this.addLabel(this.jsonTemp,[], this.handleArea, this.handleAreaFailed)

          }else{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "当前暂无被选择区域"
              this.$store.state.snackbarType = 'error'
          }
      },
      handleArea(data){
          this.$store.state.handleNodeOption = "add"//添加
          //添加name的中心点
          this.polygonJson.polygonNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates:data.geoJson.geo.properties.center
              },
              id: data.geoJson.geo.id,
              properties: {
                  "type":'point',
                  "name":data.geoJson.geo.properties.name,
                  "visible":"visible",
                  "country":'',
                  "addrName":'',
                  "imageList":[],
                  "secondId":''
              },
          })
          this.polygonJson.polygonGeo.features.push(data.geoJson.geo)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          //赋值
          this.selectItems.geo = data.geoJson.geo
          this.editSelectItems.geo = data.geoJson.geo

          this.propertiesEditCardShow = true
          this.map.doubleClickZoom.enable();
          //this.drawToolsChoose = ''
          //this.drawToolsOldChose = ''
          //this.hideLayer('visible')
          this.labelPushInFolder(data)
          this.mapMarkerStatus(data.geoJson.geo.id,data.geoJson.geo.properties.width)
      },
      handleAreaFailed(message){
          this.map.doubleClickZoom.enable();
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = message
          this.$store.state.snackbarType = 'error'
      },
      finishDrawArea(){
          this.map.off('mousemove','area-children-fill',this.areaMousemoveEvent)
          this.map.off('mouseleave','area-children-fill',this.areaMouseleaveEvent)
          this.map.off('click','area-children-fill',this.areaClickEvent)
          this.map.off('click',this.areaFatherClickEvent)
      },
      closeAreaCard(){
          this.areaCardShow = false
          this.clearLayerAndSource()
          this.finishDrawArea()
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          this.hideLayer('visible')
          this.popup.remove()
      },
      closeAreaDraw(){
          this.areaCardShow = false
          this.clearLayerAndSource()
          this.finishDrawArea()
          this.hideLayer('visible')
      },
      //监控键盘esc事件
      keyupEvent(e){
          if (e.keyCode === 27) {
              if(this.jsonTemp.properties.type === 'lineString'){
                  this.finishLineDraw()
              }else if(this.jsonTemp.properties.type === 'point'){
                  this.finishMarkerDraw()
              }else if(this.jsonTemp.properties.type === 'roadString'){
                  this.finishRoadDraw()
                 this.roadClickLength = 0
              }else if(this.jsonTemp.properties.type === 'circle'){
                  this.finishCircleDraw()
              }else if(this.jsonTemp.properties.type === 'polygon'){
                  this.finishPolygonDraw()
              }else if(this.jsonTemp.properties.type === 'rectangle'){
                  this.finishRectangleDraw()
              }else if(this.jsonTemp.properties.type === 'administrativeArea'){
                  this.closeAreaCard()
              }
              this.isDraw = false;
              this.map.getCanvas().style.cursor = 'default';
              document.getElementById("labelCanvas").style.cursor = 'default';
              //清除选择按钮
              this.drawToolsOldChose = 'selectTool'
              this.drawToolsChoose = 'selectTool'
              this.clearLayerAndSource()
              this.map.doubleClickZoom.enable()
              document.removeEventListener('keyup', this.keyupEvent);
          }
      },
      //获取ID
     async getGeneratorId(method){
        this.$axios.get('/authorApi/z-geo-file/getGeneratorId').then((res)=>{
            if(res.data.status === 200){
                method(res.data.data)
            }
        })
      },
      //关闭属性编辑弹窗
      closeEditCard() {
          if(this.isEditMarker){
              this.cancelSave()
          }else{
              if(this.isEditArea){
                  this.cancelChangeArea()
              }
          }
          this.propertiesEditCardShow = false;
          this.editNameText = ''
          this.editAddrText = ''
          this.editRemarkText = ''
          this.pointInfoShow = false
          this.settingShow = false
          this.selectItems={
              points:[],
              geo:{
                  type:'Feature',
                  id: '',//id
                  geometry: {
                      type: '',
                      coordinates: []
                  },
                  properties: {
                      "id":'',
                      "type":'',
                      "name":"",
                      "code": '',
                      "color": '',
                      "remark": "",
                      "visible":"",
                      "country":'',
                      "addrName":'',
                      "imageList":[],
                      "size":1,
                      "len":0,
                      "width":1,
                      "area":0,
                      "lineColor":'',
                      "center":[],
                      "graphArea":'',
                      'userId':'',
                      'nickName':'',
                  },
              }
          }
          this.editSelectItems={
              points:[],
              geo:{
                  type:'Feature',
                  id: '',//id
                  geometry: {
                      type: '',
                      coordinates: []
                  },
                  properties: {
                      "id":'',
                      "type":'',
                      "name":"",
                      "code": '',
                      "color": '',
                      "remark": "",
                      "visible":"",
                      "country":'',
                      "addrName":'',
                      "imageList":[],
                      "size":1,
                      "len":0,
                      "width":1,
                      "area":0,
                      "lineColor":'',
                      "center":[],
                      "graphArea":'',
                      'userId':'',
                      'nickName':'',
                  },
              }
          }
      },
      //清除左侧列表选中
      cancelLeftSelect(){
          this.$refs.mainGlobeOperation.cancelSelect()
      },
      clickCloseEditCard(){
          this.closeEditCard()
          this.cancelLeftSelect()
      },
      getLabelLockStatus(id,method){
          this.$axios.get('/authorApi/z-geo-file/getLabelLockStatus',{
              params:{
                  fileId:this.$store.state.currFolderId,
                  labelId:id
              }
          }).then((res)=>{
              if(res.data.status === 200){
                 // this.$store.state.selectNode.data.avatar = res.data.data.avatar
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = "该数据已被锁定"
                  this.$store.state.snackbarType = 'error'
              }else{
                  method()
              }
          })
          //     .catch(()=>{
          //     method()
          // })
      },
      startEditLabel(id,method){
          let data = new FormData()
          data.append('fileId',this.$store.state.currFolderId)
          data.append('labelId',id)
          this.$axios.post('/authorApi/z-geo-file/startEditLabel',data)
              .then((res)=>{
                  if(res.data.status == 200){
                      method()
                  }else{
                      this.$store.state.snackbarShow=true
                      this.$store.state.snackbarText = res.data.message
                      this.$store.state.snackbarType = 'error'
                  }
              }).catch(()=>{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "该数据已被锁定"
              this.$store.state.snackbarType = 'error'
          })
      },
      //编辑询问书否有锁
      isEditCardContext(){
          //团队文件编辑
          if(this.$store.state.currFolderType === 1)
              this.getLabelLockStatus(this.selectItems.geo.id,this.isEditCardContext1)
          else
              this.isEditCardContext2()//个人文件跳过锁状态
      },
      //询问后申请加锁
      isEditCardContext1(){
          this.startEditLabel(this.selectItems.geo.id,this.isEditCardContext2)
      },
      isEditCardContext2() {
          this.isEditMarker = true
          this.editNameText = this.editSelectItems.geo.properties.name
          this.editAddrText = this.editSelectItems.geo.properties.addrName
          this.editRemarkText = this.editSelectItems.geo.properties.remark
          this.$store.state.handleNodeOption = 'modify'//修改操作
      },
      //取消接口
      cancelSave(){
          this.isEditMarker = false
          this.$store.state.handleNodeOption = ''
          // //中间态恢复到初始状态
          // this.editSelectItems.geo = this.deepClone(this.selectItems.geo)
          // this.editSelectItems.points = []
          // this.editSelectItems.points.push(...this.selectItems.points)
          //团队文件
          if(this.$store.state.currFolderType === 1)
              this.cancelEditLabel()
      },
      cancelEditLabel(){
          let data = new FormData()
          data.append('fileId',this.$store.state.currFolderId)
          data.append('labelId',this.selectItems.geo.id)
          this.$axios.post('/authorApi/z-geo-file/cancelEditLabel',data)
      },
      //保存编辑
      editCardSave(){
          this.editSelectItems.geo.properties.name = this.editNameText
          this.editSelectItems.geo.properties.addrName =this.editAddrText
          this.editSelectItems.geo.properties.remark =this.editRemarkText
          if(this.editSelectItems.geo.properties.type === 'administrativeArea'){
              let temp = ''
              if(this.provinceNow !== ''){
                  temp = this.provinceItems.find((item)=>{return item.id === this.provinceNow}).name
                  if(this.cityNow !=='')
                      temp = temp+"-"+this.cityItems.find((item)=>{return item.id === this.cityNow}).name
                  if(this.countyNow !=='')
                      temp = temp+"-"+this.countyItems.find((item)=>{return item.id === this.countyNow}).name
                  //存贮值
                  this.currentBoundary.geometry.type = this.deepClone(this.editSelectItems.geo.geometry.type)
                  this.currentBoundary.geometry.coordinates = this.deepClone(this.editSelectItems.geo.geometry.coordinates)
                  this.currentBoundary.properties.center = this.deepClone(this.editSelectItems.geo.properties.center)
                  this.areaName = this.deepClone(temp)
                  this.editSelectItems.geo.properties.graphArea = this.deepClone(temp)
                  //关闭当前编辑区域
                  this.provinceNow = ''
                  this.cityNow =''
                  this.countyNow = ''
              }
          }
          //组数据
          let data =  {
              id:this.selectNode.data.id,
              name:this.editSelectItems.geo.properties.name,
              type:this.editSelectItems.geo.properties.type,
              visible:this.selectNode.data.visible,
              iconShow:this.selectNode.data.iconShow,
              isEditName:false,
              geoJson:{
                  points:this.editSelectItems.points,
                  geo:this.editSelectItems.geo,
              },
              children:[]
          }
          this.$axios({
              method:"post",
              url:"/authorApi/z-geo-file/editLabel",
              data:{
                  fileId:this.$store.state.currFolderId,
                  labelNode:data,
              }
          }).then((res)=>{
              if(res.data.status === 200){
                  //数据更新处理
                  this.selectItems.geo = res.data.data.geoJson.geo
                  this.selectItems.points = []
                  this.selectItems.points.push(...res.data.data.geoJson.points)
                  //辅助数据更新处理
                  this.editSelectItems.geo = res.data.data.geoJson.geo
                  this.editSelectItems.points = []
                  this.editSelectItems.points.push(...res.data.data.geoJson.points)
                  //编辑状态关闭
                  this.isEditMarker = false
                  this.$store.state.handleNodeOption = ''
                  this.notSavedDialog = false
                  //
                  this.editNameText =''
                  this.editAddrText =''
                  this.editRemarkText =''
                  //左侧列表数据同步
                  this.selectNode.data.name = res.data.data.name
                  this.selectNode.data.geoJson.geo = res.data.data.geoJson.geo
                  this.selectNode.data.geoJson.points= []
                  this.selectNode.data.geoJson.points.push(...res.data.data.geoJson.points)
                  //消息弹窗
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = "数据已保存至云端"
                  this.$store.state.snackbarType = 'success'
                  //地图数据更新
                  this.mapDataUpdate(res.data.data.geoJson)
              }else{
                  //取消了更新
                  this.cancelSave()
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = "数据保存失败"
                  this.$store.state.snackbarType = 'error'
              }
          }).catch(()=>{
              //取消了更新
              this.cancelSave()
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "数据保存失败"
              this.$store.state.snackbarType = 'error'
          })

      },
      mapDataUpdate(geoJson){
          const map={
              "point":this.pointMapDataUpdate(geoJson),
              "lineString":this.lineMapDataUpdate(geoJson),
              "roadString":this.roadMapDataUpdate(geoJson),
              "circle":this.polygonMapDataUpdate(geoJson),
              "rectangle":this.polygonMapDataUpdate(geoJson),
              "polygon":this.polygonMapDataUpdate(geoJson),
              "administrativeArea":this.polygonMapDataUpdate(geoJson),
          }
          return map[geoJson.geo.properties.type]
      },
      pointMapDataUpdate(geoJson){
          this.markerList.features = this.markerList.features.map((item) => item.id === geoJson.geo.id ? geoJson.geo : item)
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      lineMapDataUpdate(geoJson){
              this.lineJson.lineNamePoint.features= this.lineJson.lineNamePoint.features.map((item)=>{
                  if(item.id === geoJson.geo.id){
                      item.properties.name =geoJson.geo.properties.name
                  }
                  return item
              })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>item.id === geoJson.geo.id ? geoJson.geo : item)

          this.lineJson.linePoint.features = this.lineJson.linePoint.features.map((item)=>{
              for(let i = 0; i < geoJson.points.length;i++){
                  if(item.properties.secondId === geoJson.points[i].properties.secondId &&item.id ===geoJson.points[i].id){
                      item.properties.color =this.deepClone(geoJson.geo.properties.color)
                      item.properties.name =this.deepClone(geoJson.points[i].properties.name)
                  }
              }
              return item
          })
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint)
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo)
          this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
      },
      roadMapDataUpdate(geoJson){
              this.roadJson.roadNamePoint.features= this.roadJson.roadNamePoint.features.map((item)=>{
                  if(item.id === geoJson.geo.id){
                      item.properties.name =geoJson.geo.properties.name
                  }
                  return item
              })
              this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)

          this.roadJson.roadGeo.features = this.roadJson.roadGeo.features.map((item)=>item.id === geoJson.geo.id ? geoJson.geo : item)
          this.roadJson.roadPoint.features = this.roadJson.roadPoint.features.map((item)=>{
              for(let i = 0; i < geoJson.points.length;i++){
                  if(item.properties.secondId === geoJson.points[i].properties.secondId && item.id ===geoJson.points[i].id){
                      item.properties.color =this.deepClone(geoJson.geo.properties.color)
                      item.properties.name =this.deepClone(geoJson.points[i].properties.name)
                  }
              }
              return item
          })
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint);
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)

      },
      polygonMapDataUpdate(geoJson){
          if(geoJson.geo.properties.type === 'administrativeArea'){
              this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
                  if(item.id === geoJson.geo.id){
                      item.properties.name =geoJson.geo.properties.name
                      item.geometry.coordinates = geoJson.geo.properties.center
                  }
                  return item
              })
          }else{
              this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
                  if(item.id === geoJson.geo.id){
                      item.properties.name =geoJson.geo.properties.name
                  }
                  return item
              })
          }
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>item.id === geoJson.geo.id ? geoJson.geo : item)
          if(geoJson.points.length >0){
              this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.map((item)=>{
                  for(let i = 0; i < geoJson.points.length;i++){
                      if(item.properties.secondId === geoJson.points[i].properties.secondId && item.id ===geoJson.points[i].id){
                          item.properties.color =this.deepClone(geoJson.geo.properties.lineColor)
                          item.properties.name =this.deepClone(geoJson.points[i].properties.name)
                      }
                  }
                  return item
              })
              this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          }
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo)
          //跳转到相应位置
          if(geoJson.geo.properties.type === 'administrativeArea')
              this.mapFitBoundary(geoJson.geo)
      },

      //名字编辑组件回调修改名字
      changeName(val){
          this.editSelectItems.points[val.index].properties.name = val.text
          // let point = this.selectItems.points[val.index]
      },
      //地点编辑组件回调修改地点
      changeAddrName(val){
          this.editSelectItems.points[val.index].properties.addrName = val.addr
      },
      //图片添加组件回调修改
      addItem(val){
          this.editSelectItems.points[val.index].properties.imageList = val.list
      },
      //改变尺寸图标
      changeSize(val){
          this.editSelectItems.geo.properties.size = val
      },
      //选择图标
      changeIcon(item){
          this.editSelectItems.geo.properties.code = item.name
      },
      //改变颜色
      changeColor(val){
          if(val.type ==='color'){
              this.editSelectItems.geo.properties.color = val.color
              if(this.editSelectItems.geo.properties.type === 'lineString'||this.editSelectItems.geo.properties.type ==='roadString'){
                  for(let i = 0;i<this.editSelectItems.points.length;i++){
                      this.editSelectItems.points[i].properties.color = val.color
                  }
              }
          }else{
              this.editSelectItems.geo.properties.lineColor =  val.color
              for(let i = 0;i<this.editSelectItems.points.length;i++){
                  this.editSelectItems.points[i].properties.color = val.color
              }
          }
      },
      //改变线条宽度
      changeValue(){
         //目前不需要处理
      },
      //修改视频和图片
      addImageAndVideo(temp) {
          this.editSelectItems.geo.properties.imageList.push(temp)
      },
      removeMedia(val){
          this.editSelectItems.geo.properties.imageList=this.deepClone(val)
      },
      //修改name属性
      editName(val){
        this.isEditName = true
          this.editNameText = val
      },
      blurEditNameText(){
        if(this.editNameText.length >0 && this.editNameText.length < 21){
            this.selectNode.data.name = this.deepClone(this.editNameText)
            //左侧文件属性编辑
            this.selectNode.data.geoJson.geo.properties.name = this.deepClone(this.editNameText)
            //离开页面属性
            this.selectItems.geo.properties.name =this.editNameText
            this.isEditName =false
            if(this.selectItems.geo.properties.type === 'point')
                //做数据处理
                this.pointDataHanding(1)
            else if(this.selectItems.geo.properties.type === 'lineString')
                this.lineDataHanding('name')
            else if(this.selectItems.geo.properties.type === 'rectangle'|| this.selectItems.geo.properties.type === 'polygon'||this.selectItems.geo.properties.type === 'circle'||this.selectItems.geo.properties.type === 'administrativeArea')
                this.rectangleDataHanding('name')
            else if(this.selectItems.geo.properties.type === 'roadString')
                this.roadDataHanding('name')

        }else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "长度不符合要求"
            this.$store.state.snackbarType = 'error'
            this.isEditName =false
        }
      },
      //修改地址
      editAddr(val){
        this.isEditAddr = true
          this.editAddrText = val
      },
      blurEditAddrText(){
          if(this.editAddrText.length >0 && this.editAddrText.length < 31){
              //左侧文件属性编辑
              this.selectNode.data.geoJson.geo.properties.addrName = this.deepClone(this.editAddrText)
              //离开页面属性
              this.isEditAddr =false
              this.selectItems.geo.properties.addrName =this.editAddrText
              if(this.selectItems.geo.properties.type === 'point')
                //做数据处理
                this.pointDataHanding(0)
          }else{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "长度不符合要求"
              this.$store.state.snackbarType = 'error'
              this.isEditAddr =false
          }
      },
      //上传视频和图片
      getFile(){
        if(this.selectItems.geo.properties.imageList.length < 15){
            let file =this.$refs.uploadPictureAndVideo.files[0];
            if(file.type === "video/mp4" || file.type === "video/wmv" || file.type === "video/avi"){
                this.uploadVideo(file)
            }else if(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif'){
                this.uploadPicture(file)
            }else{
                this.$store.state.snackbarShow=true
                this.$store.state.snackbarText = "文件格式错误"
                this.$store.state.snackbarType = 'error'
            }
        }else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "最多上传15张"
            this.$store.state.snackbarType = 'error'
        }

      },
      uploadPicture(file){
        if(file.size < 1024 * 1024 * 20){
            this.showLoadingDialog = true
            let paramData = new FormData();
            paramData.append('multipartFile',file);
            this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                .then((resultData)=>{
                    resultData = resultData.data;
                    if(resultData.status === 200){
                        let picture={
                            type:'image',
                            url:resultData.data.picture,
                            thumb:resultData.data.thumb,
                        }
                        this.addImageAndVideo(picture)
                    }
                    this.$refs.uploadPictureAndVideo.value = ''
                    this.showLoadingDialog = false
                })
        }else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "文件大小不能超过20M"
            this.$store.state.snackbarType = 'error'
        }
      },
      uploadVideo(file){
        if(file.size < 1024 * 1024 * 500){
            this.showLoadingDialog = true
            let data = new FormData()
            data.append('multipartFile',file)
            this.$axios.post('/managerApi/upoladFile/uploadVideo',data)
                .then((resultData)=>{
                    resultData = resultData.data;
                    if(resultData.status === 200){
                        let video={
                            type:'video',
                            url:resultData.data.picture,
                            thumb:resultData.data.thumb,
                        }
                        this.addImageAndVideo(video)
                    }
                    this.$refs.uploadPictureAndVideo.value = ''
                    this.showLoadingDialog = false
                })
        }else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "文件大小不能超过500M"
            this.$store.state.snackbarType = 'error'
        }
      },
      goToView(val){
          if(val ===1)
              this.showDelete = true
          else
              this.showDelete = false
          this.$refs.previewer.showPreviewDialog = true
      },

      //编辑备注
      editRemark(val){
        this.isEditRemark = true
          this.editRemarkText = val
      },
      saveRemark(){
          if(this.editRemarkText.length >0 && this.editRemarkText.length < 101){
              this.isEditRemark =false
              this.selectItems.geo.properties.remark = this.editRemarkText
              //左侧文件属性编辑
              this.selectNode.data.geoJson.geo.properties.remark = this.deepClone(this.editRemarkText)
              //离开页面属性
              if(this.selectItems.geo.properties.type === 'point')
                  //做数据处理
                  this.pointDataHanding(0)
              else if(this.selectItems.geo.properties.type === 'lineString')
                  this.lineDataHanding('remark')
              else if(this.selectItems.geo.properties.type === 'rectangle'||this.selectItems.geo.properties.type === 'polygon'||this.selectItems.geo.properties.type === 'circle'||this.selectItems.geo.properties.type === 'administrativeArea')
                  this.rectangleDataHanding('remark')
          }else{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "长度不符合要求"
              this.$store.state.snackbarType = 'error'
              this.isEditAddr =false
          }
      },

      errorUploadValue(val){
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = val
          this.$store.state.snackbarType = 'error'
      },
      //行政区域修改所属区域
      editArea(id){
          this.$axios.get('/authorApi/a-area-geo/getAreaGeoById',{
              params:{
                  id:id
              }
          }).then((res)=>{
              if(res.data.status === 200){
                  this.editSelectItems.geo.geometry.type = res.data.data.features[0].geometry.type
                  this.editSelectItems.geo.geometry.coordinates = this.deepClone(res.data.data.features[0].geometry.coordinates)
                  this.editSelectItems.geo.properties.center = this.deepClone(res.data.data.features[0].properties.center)



                  // this.selectItems.geo.geometry.type = res.data.data.features[0].geometry.type
                  // this.selectItems.geo.geometry.coordinates = this.deepClone(res.data.data.features[0].geometry.coordinates)
                  // this.selectItems.geo.properties.center = this.deepClone(res.data.data.features[0].properties.center)
              }
          })
      },
      changeProvince($event){
          this.cityNow = ''
          this.countyNow=''
          this.cityItems = []
          this.countyItems = []
          if(this.provinceNow !==''){
              this.$axios.get('/authorApi/a-area-geo/getChildNameListById',{
                  params:{
                      id:this.provinceNow
                  }
              }).then((res)=>{
                  if(res.data.status === 200){
                      this.cityItems = res.data.data
                  }
              })
              this.editArea($event)
          }
      },
      changeCity($event){
          this.countyNow=''
          this.countyItems = []
          if(this.cityNow !==''){
              this.$axios.get('/authorApi/a-area-geo/getChildNameListById',{
                  params:{
                      id:this.cityNow
                  }
              }).then((res)=>{
                  if(res.data.status === 200){
                      this.countyItems = res.data.data
                  }
              })
              this.editArea($event)
          }
      },
      changeCounty($event){
          this.editArea($event)
      },
      cancelChangeArea(){
          this.selectItems.geo.geometry.type = this.deepClone(this.currentBoundary.geometry.type)
          this.selectItems.geo.geometry.coordinates = this.deepClone(this.currentBoundary.geometry.coordinates)
          this.selectItems.geo.properties.graphArea =this.areaName
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>item.id === this.selectItems.geo.id ? this.selectItems.geo : item)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo)
          this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
              if(item.id === this.selectItems.geo.id){
                  item.geometry.coordinates =this.deepClone(this.currentBoundary.properties.center)
              }
              return item
          })
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.mapFitBoundary(this.currentBoundary)
          this.provinceNow = ''
          this.cityNow =''
          this.countyNow = ''
          this.isEditArea =false
      },
      sureChangeArea(){
          let temp = ''
          if(this.provinceNow !== ''){
              temp = this.provinceItems.find((item)=>{return item.id === this.provinceNow}).name
              if(this.cityNow !=='')
                  temp = temp+"-"+this.cityItems.find((item)=>{return item.id === this.cityNow}).name
              if(this.countyNow !=='')
                  temp = temp+"-"+this.countyItems.find((item)=>{return item.id === this.countyNow}).name
              //存贮值
              this.currentBoundary.geometry.type = this.deepClone(this.selectItems.geo.geometry.type)
              this.currentBoundary.geometry.coordinates = this.deepClone(this.selectItems.geo.geometry.coordinates)
              this.currentBoundary.properties.center = this.deepClone(this.selectItems.geo.properties.center)
              this.areaName = this.deepClone(temp)
              this.selectItems.geo.properties.graphArea = this.deepClone(temp)
              //左侧文件属性编辑
              this.selectNode.data.geoJson.geo.properties.graphArea = this.deepClone(temp)
              this.selectNode.data.geoJson.geo.properties.center = this.deepClone(this.selectItems.geo.properties.center)
              this.selectNode.data.geoJson.geo.geometry.type = this.deepClone(this.selectItems.geo.geometry.type)
              this.selectNode.data.geoJson.geo.geometry.coordinates = this.deepClone(this.selectItems.geo.geometry.coordinates)
              //离开页面属性
              //关闭当前编辑区域
              this.provinceNow = ''
              this.cityNow =''
              this.countyNow = ''
              this.isEditArea =false
          }else{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "请选择区域"
              this.$store.state.snackbarType = 'error'
          }
      },
      //数据处理
      pointDataHanding(isSetData){
          this.markerList.features = this.markerList.features.map((item) => item.id === this.selectItems.geo.id ? this.selectItems.geo : item)
          if(isSetData === 1)
              this.map.getSource('markerLayer').setData(this.markerList)
        //点标记出来

      },
      lineDataHanding(type){
        if(type === "name"){
            this.lineJson.lineNamePoint.features= this.lineJson.lineNamePoint.features.map((item)=>{
               if(item.id === this.selectItems.geo.id){
                   item.properties.name =this.selectItems.geo.properties.name
               }
               return item
            })
            this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
        }
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>item.id === this.selectItems.geo.id ? this.selectItems.geo : item)
          if(type === 'color'){
              this.lineJson.linePoint.features = this.lineJson.linePoint.features.map((item)=>{
                  if(item.id == this.selectItems.geo.id){
                      item.properties.color =this.deepClone(this.selectItems.geo.properties.color)
                  }
                  return item
              })
              this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
              this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          }
          if(type === 'width'){
              this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          }
      },
      rectangleDataHanding(type){
        if(type === 'name'){
            this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
                if(item.id === this.selectItems.geo.id){
                    item.properties.name =this.selectItems.geo.properties.name
                }
                return item
            })
            this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
        }
        this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>item.id === this.selectItems.geo.id ? this.selectItems.geo : item)
          if(type ==='color'){
              this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.map((item)=>{
                  if(item.id == this.selectItems.geo.id){
                      item.properties.color =this.deepClone(this.selectItems.geo.properties.lineColor)
                  }
                  return item
              })
              this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
              this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo)
          }

          if(type === 'width'){
              this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo)
          }
      },
      roadDataHanding(type){
          if(type === "name"){
              this.roadJson.roadNamePoint.features= this.roadJson.roadNamePoint.features.map((item)=>{
                  if(item.id === this.selectItems.geo.id){
                      item.properties.name =this.selectItems.geo.properties.name
                  }
                  return item
              })
              this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
          }
          this.roadJson.roadGeo.features = this.roadJson.roadGeo.features.map((item)=>item.id === this.selectItems.geo.id ? this.selectItems.geo : item)

          if(type === 'color'){
              this.roadJson.roadPoint.features = this.roadJson.roadPoint.features.map((item)=>{
                  if(item.id == this.selectItems.geo.id){
                      item.properties.color =this.deepClone(this.selectItems.geo.properties.color)
                  }
                  return item
              })
              this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint);
              this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          }
          if(type ==='color' || type === 'width'){
              this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          }
      },
      //清理多余图层
      clearLayerAndSource(){
          if (this.map.getLayer('points')) {
              this.map.removeLayer('points')
          }
          if (this.map.getSource('points')) {
              this.map.removeSource('points');
          }
          if (this.map.getLayer('line')) {
              this.map.removeLayer('line')
          }
          if (this.map.getSource('line')) {
              this.map.removeSource('line');
          }
          if (this.map.getLayer('line-move')) {
              this.map.removeLayer('line-move')
          }
          if (this.map.getSource('line-move')) {
              this.map.removeSource('line-move');
          }

          if (this.map.getLayer('road-points')) {
              this.map.removeLayer('road-points')
          }
          if (this.map.getSource('road-points')) {
              this.map.removeSource('road-points');
          }
          if (this.map.getLayer('road-line')) {
              this.map.removeLayer('road-line')
          }
          if (this.map.getSource('road-line')) {
              this.map.removeSource('road-line');
          }
          if (this.map.getLayer('road-line-move')) {
              this.map.removeLayer('road-line-move')
          }
          if (this.map.getSource('road-line-move')) {
              this.map.removeSource('road-line-move');
          }

          if (this.map.getLayer('rectangle')) {
              this.map.removeLayer('rectangle')
          }
          if (this.map.getSource('rectangle')) {
              this.map.removeSource('rectangle');
          }
          if (this.map.getLayer('points-area')) {
              this.map.removeLayer('points-area')
          }
          if (this.map.getSource('points-area')) {
              this.map.removeSource('points-area');
          }
          if (this.map.getLayer('line-area-stroke')) {
              this.map.removeLayer('line-area-stroke')
          }
          if (this.map.getSource('line-area-stroke')) {
              this.map.removeSource('line-area-stroke');
          }
          if (this.map.getLayer('line-area-move')) {
              this.map.removeLayer('line-area-move')
          }
          if (this.map.getSource('line-area-move')) {
              this.map.removeSource('line-area-move');
          }
          if (this.map.getLayer('line-area')) {
              this.map.removeLayer('line-area')
          }
          if (this.map.getSource('line-area')) {
              this.map.removeSource('line-area');
          }
          if(this.map.getLayer('circle-point-stroke')){
              this.map.removeLayer('circle-point-stroke')
          }
          if (this.map.getLayer('circle')) {
              this.map.removeLayer('circle')
          }
          if (this.map.getSource('circle')) {
              this.map.removeSource('circle');
          }
          if (this.map.getLayer('circle-point')) {
              this.map.removeLayer('circle-point')
          }
          if (this.map.getSource('circle-point')) {
              this.map.removeSource('circle-point');
          }

          if (this.map.getLayer('area-father')) {
              this.map.removeLayer('area-father')
          }
          if (this.map.getLayer('area-father-fill')) {
              this.map.removeLayer('area-father-fill')
          }
          if (this.map.getSource('area-father')) {
              this.map.removeSource('area-father');
          }
          if (this.map.getLayer('area-boundary')) {
              this.map.removeLayer('area-boundary')
          }
          if (this.map.getSource('area-boundary')) {
              this.map.removeSource('area-boundary');
          }
          if (this.map.getLayer('area-children-fill')) {
              this.map.removeLayer('area-children-fill')
          }
          if (this.map.getSource('area-children-fill')) {
              this.map.removeSource('area-children-fill');
          }
      },
      //整理线段长度方法
      lengthUomConversion(len){
        if(len >1000)
            return (len/1000).toFixed(2) +"千米"
          else
            return len.toFixed(2) +"米"
      },
      //面积整理
      areaUomConversion(area){
          if(area >1000000)
              return (area/1000000).toFixed(2)+"平方千米"
          else
              return area.toFixed(2)+"平方米"
      },
      //测量的部分
      isMeasureShow(){
        if(this.measureCardShow){
            this.clearAllMeasure()
        }else{
            this.measureCardShow = !this.measureCardShow
            this.closeEditCard()
            this.cleanMapOnEvent()
            this.drawToolsOldChose = 'selectTool'
            this.drawToolsChoose = 'selectTool'
        }
      },
      selectMeasureTool(val){
          if(this.measureToolChoose !== val){
              this.measureToolChoose = val
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "点击地图开始测量，双击完成测量，按ESC键取消测量"
              this.$store.state.snackbarType = 'info'
              this.clickCloseEditCard()
              if(val ==='len')
                  this.measureLength()
              else
                  this.measureArea()
          }
      },
      measureLength(){
          this.clearMeasureSource()
          this.finishAreaMeasureDraw()
          this.finishMeasureDraw()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //定义数据
          this.isDraw = true;
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonNamePoint.features = []
          this.pointArray = []
          let ele = document.createElement('div')
          ele.setAttribute('class','measure-result')
          let opion = {
              element: ele,
              anchor: 'center',
              offset: [0, -20]
          }
          let ele1 = document.createElement('div')
          ele1.setAttribute('class','measure-result')
          let opion1 = {
              element: ele1,
              anchor: 'center',
              offset: [0, -20]
          }
          //ele.innerHTML = 0
          this.mapMarker = new mapboxgl.Marker(opion)
          this.mapStartMarker = new mapboxgl.Marker(opion1)
          //添加图层
          let source = this.map.getSource('measure-points');
          let lineMoveSource =this.map.getSource('measure-line-move');
          let lineSource = this.map.getSource('measure-line');
          if(source) {
              this.map.getSource('measure-points').setData(this.jsonPoint);
              if (lineMoveSource) {
                  this.map.getSource('measure-line-move').setData(this.jsonLine);
              }
              if (lineSource) {
                  this.map.getSource('measure-line').setData(this.jsonLine);
              }
          }else{
              //添加图层
              this.map.addSource('measure-points', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addSource('measure-line', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('measure-line-move', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('measure-line-name',{
                  type: 'geojson',
                  data: this.jsonNamePoint
              })
              this.map.addLayer({
                  id: 'measure-line-move',
                  type: 'line',
                  source: 'measure-line-move',
                  paint: {
                      'line-color': '#00BAAD',
                      'line-width': 3,
                      'line-opacity': 1,
                      'line-dasharray': [3, 1]
                  }
              });
              this.map.addLayer({
                  id: 'measure-line',
                  type: 'line',
                  source: 'measure-line',
                  paint: {
                      'line-color': '#00BAAD',
                      'line-width': 2,
                      'line-opacity': 1
                  }
              });
              this.map.addLayer({
                  id: 'measure-points',
                  type: 'circle',
                  source: 'measure-points',
                  paint: {
                      'circle-color': '#00BAAD',
                      'circle-radius': 5,
                      'circle-stroke-width': 2,
                      'circle-stroke-color': '#ffffff'
                  }
              });
              this.map.addLayer({
                  id: 'measure-line-name',
                  type: 'symbol',
                  source: 'measure-line-name',
                  layout:{
                      "text-field": ["get", "name"],
                      "text-font":this.$store.state.font,
                      "text-size":14,
                      "text-anchor": "center",
                     // "text-offset": [0,0],
                      // "text-rotate":["get", "rotate"]
                  },
                  paint:{
                      "text-color": "#ffffff",
                      "text-halo-color":'rgba(0, 0, 0, 1)',
                      "text-halo-blur":1,
                      "text-halo-width": 2,
                  }
              })
              // this.map.addLayer({
              //     id: 'measure-line-first-name',
              //     type: 'symbol',
              //     source: 'measure-points',
              //     layout:{
              //         "text-field": ["get", "name"],
              //         "text-size":14,
              //         "text-anchor": "top",
              //         "text-offset": [0,-2],
              //     },
              //     paint:{
              //         "text-color": "#ffffff",
              //         "text-halo-color":'rgba(0, 0, 0, 1)',
              //         "text-halo-blur":1,
              //         "text-halo-width": 1,
              //     }
              // })
          }
          this.map.on('click',this.measureClickEvent)
          this.map.on('dblclick',this.measureDblclickEvent)
          this.map.on('mousemove',this.measureMousemoveEvent)
          this.map.on('contextmenu',this.measureContextMenuEvent)
          document.addEventListener('keyup', this.keyupMeasureEvent)
      },
      measureClickEvent(e){
        if(this.isDraw){
            let coords = [e.lngLat.lng, e.lngLat.lat]
            if(this.jsonPoint.features.length >0){
                let prev = this.jsonPoint.features[this.jsonPoint.features.length - 1];
                this.jsonLine.features.push({
                    type: 'Feature',
                    geometry: {
                        type: 'LineString',
                        coordinates: [prev.geometry.coordinates, coords]
                    }
                });
                this.map.getSource('measure-line').setData(this.jsonLine);
                if(prev.geometry.coordinates[0] !==coords[0] && prev.geometry.coordinates[1] !==coords[1]){
                    this.jsonPoint.features.push({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: coords
                        },
                        properties:{
                            name:''
                        }
                    })
                    this.map.getSource('measure-points').setData(this.jsonPoint);
                    this.pointArray.push(coords)
                    this.measureClickDataT(prev.geometry.coordinates,coords)
                }
            }else{
                this.jsonPoint.features.push({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: coords
                    },
                    properties:{
                        name:'起点'
                    }
                })
                this.mapStartMarker.getElement().innerHTML = '起点'
                this.mapStartMarker.setLngLat(coords)
                this.mapStartMarker.addTo(this.map)
                this.pointArray.push(coords)
                this.map.getSource('measure-points').setData(this.jsonPoint);
            }
        }
      },
      measureMousemoveEvent(e){
          if(this.isDraw){
              let coords = [e.lngLat.lng, e.lngLat.lat];
              if (this.jsonPoint.features.length > 0) {
                  let prev = this.jsonPoint.features[this.jsonPoint.features.length - 1];
                  let json = {
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: [prev.geometry.coordinates, coords]
                      }
                  };
                  this.map.getSource('measure-line-move').setData(json);
                  this.mapMarker.getElement().innerHTML =  this.getLength(this.pointArray.concat([coords]));
                  this.mapMarker.setLngLat(coords)
                  this.mapMarker.addTo(this.map);
              }
          }
      },
      measureDblclickEvent(){
          if(this.isDraw) {
              if(this.jsonPoint.features.length >0){
                  //数据处理
                  this.measureLengthEndDataT()
              }
          }
      },
      measureContextMenuEvent(){
          if(this.isDraw) {
              if(this.jsonPoint.features.length >1){
                  this.map.getSource('measure-points').setData(this.jsonPoint);
                  this.map.getSource('measure-line-move').setData({
                      type: 'Feature',
                      geometry: {
                          type: 'LineString',
                          coordinates: []
                      }
                  })
                  this.measureLengthEndDataT()
              }
          }
      },
      measureLengthEndDataT(){
          //地图绘制
          this.jsonPoint.features[this.jsonPoint.features.length-1].properties.name = this.getLength(this.pointArray)
          this.measureLengthJson.measurePoint.features.push(...this.jsonPoint.features)
          this.measureLengthJson.measureGeo.features.push(...this.jsonLine.features)
          this.measureLengthJson.measureNamePoint.features.push(...this.jsonNamePoint.features)
          this.map.getSource('measurePoints').setData( this.measureLengthJson.measurePoint);
          this.map.getSource('measureLine').setData( this.measureLengthJson.measureGeo);
          this.map.getSource('measureLineName').setData( this.measureLengthJson.measureNamePoint);
          //清空当前
         this.clearLengthData()
      },
      clearLengthData(){
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonNamePoint.features = []
          this.pointArray = []
          if((typeof this.mapMarker) === 'object'){
              this.mapMarker.remove()
          }
          if((typeof this.mapStartMarker) === 'object'){
              this.mapStartMarker.remove()
          }
          // this.mapMarker.remove()
          // this.mapStartMarker.remove()
          this.map.getSource('measure-points').setData(this.jsonPoint);
          this.map.getSource('measure-line-move').setData(this.jsonLine);
          this.map.getSource('measure-line').setData(this.jsonLine);
          this.map.getSource('measure-line-name').setData(this.jsonNamePoint);
      },
      measureClickDataT(prev,coords){
          let line = turf.lineString([prev,coords])
          let length = turf.length(line, {units: 'kilometers'})*1000
          //角度
          let point1 = turf.point(prev);
          let point2 = turf.point(coords);
          // let bearing = turf.bearing(point1, point2);
          // if(bearing>0){
          //     bearing = bearing-90
          // }else{
          //     bearing = 90-bearing
          // }
          let midpoint = turf.midpoint(point1, point2);
          this.jsonNamePoint.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: midpoint.geometry.coordinates
              },
              properties:{
                  name:this.lengthUomConversion(length),
              }
          })
          this.map.getSource('measure-line-name').setData(this.jsonNamePoint);
      },
      getLength(points){
          const line = turf.lineString(points);
          let len = turf.lineDistance(line);
          if(len < 1) {
              len = Math.round(len * 1000) + 'm';
          } else {
              len = len.toFixed(2) + 'km';
          }
          return len
      },
      finishMeasureDraw(){
          this.map.off('click',this.measureClickEvent)
          this.map.off('dblclick',this.measureDblclickEvent)
          this.map.off('mousemove',this.measureMousemoveEvent)
          this.map.off('contextmenu',this.measureContextMenuEvent)
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      measureArea(){
          if((typeof this.mapMarker) === 'object'){
              this.mapMarker.remove()
          }
          if((typeof this.mapStartMarker) === 'object'){
              this.mapStartMarker.remove()
          }
          this.clearMeasureSource()
          this.finishAreaMeasureDraw()
          this.finishMeasureDraw()
          this.map.getCanvas().style.cursor = 'crosshair';
          document.getElementById("labelCanvas").style.cursor = 'crosshair';
          this.map.doubleClickZoom.disable();
          //定义数据
          this.isDraw = true;
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonNamePoint.features = []
          this.pointArray = []
          this.pointCoord=[]
          this.jsonTemp = {
              type: 'Feature',
              geometry: {
                  type: 'Polygon',
                  coordinates:[]
              },
          }
          let source = this.map.getSource('measure-points');
          let lineSource = this.map.getSource('measure-line');
          if(source) {
              this.map.getSource('measure-points').setData(this.jsonPoint);
              if (lineSource) {
                  this.map.getSource('measure-line').setData(this.jsonLine);
              }
          }else{
              //添加图层
              this.map.addSource('measure-points', {
                  type: 'geojson',
                  data: this.jsonPoint
              });
              this.map.addSource('measure-line', {
                  type: 'geojson',
                  data: this.jsonLine
              });
              this.map.addSource('measure-line-name',{
                  type: 'geojson',
                  data: this.jsonNamePoint
              })
              this.map.addLayer({
                  id: 'measure-line-fill',
                  type: 'fill',
                  source: 'measure-line',
                  paint: {
                      'fill-color': '#00BAAD',
                      'fill-opacity': 0.5
                  }
              });
              this.map.addLayer({
                  id: 'measure-line',
                  type: 'line',
                  source: 'measure-line',
                  paint: {
                      'line-color': '#00BAAD',
                      'line-width': 1,
                      'line-opacity': 1
                  }
              });
              this.map.addLayer({
                  id: 'measure-points',
                  type: 'circle',
                  source: 'measure-points',
                  paint: {
                      'circle-color': '#00BAAD',
                      'circle-radius': 5,
                      'circle-stroke-width': 2,
                      'circle-stroke-color': '#ffffff'
                  }
              });
              this.map.addLayer({
                  id: 'measure-line-name',
                  type: 'symbol',
                  source: 'measure-line-name',
                  layout:{
                      "text-field": ["get", "name"],
                      "text-font":this.$store.state.font,
                      "text-size":14,
                      "text-anchor": "center",
                      "icon-allow-overlap":true,
                      "text-allow-overlap":true
                      // "text-offset": [0,0],
                      // "text-rotate":["get", "rotate"]
                  },
                  paint:{
                      "text-color": "#ffffff",
                      "text-halo-color":'rgba(0, 0, 0, 1)',
                      "text-halo-blur":1,
                      "text-halo-width": 1,
                  }
              })
          }
          this.map.on("click",this.measureAreaClickEvent)
          this.map.on("dblclick",this.measureAreaDblclickEvent)
          this.map.on("mousemove",this.measureAreaMousemoveEvent)
          this.map.on('contextmenu',this.measureAreaContextmenuEvent)
          document.addEventListener('keyup', this.keyupMeasureEvent)
      },
      measureAreaClickEvent(e){
        if(this.isDraw){
            let coords = [e.lngLat.lng, e.lngLat.lat]
            this.pointArray.push(coords)
            if(coords[0] !== this.pointCoord[0] && coords[1] !== this.pointCoord[1]){
                this.pointCoord = coords
                this.jsonPoint.features.push({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: coords
                    },
                })
                this.map.getSource('measure-points').setData(this.jsonPoint);
            }
        }
      },
      measureAreaDblclickEvent(){
        if(this.isDraw){
            if(this.jsonPoint.features.length >2){
                this.measureAreaEndDataT()
            }
        }
      },
      measureAreaMousemoveEvent(e){
        if(this.isDraw){
            let coords = [e.lngLat.lng, e.lngLat.lat]
            let len = this.jsonPoint.features.length
            this.jsonNamePoint.features = []
            if(len !== 0 && len !==1){
                let pts = this.pointArray.concat([coords])
                pts = pts.concat([this.pointArray[0]])
                this.jsonTemp.geometry.coordinates = [pts]
                this.map.getSource('measure-line').setData(this.jsonTemp);
                this.jsonNamePoint.features.push(...this.getLinePoint(this.jsonTemp.geometry.coordinates))
                this.map.getSource('measure-line-name').setData(this.jsonNamePoint);
            }
        }
      },
      measureAreaContextmenuEvent(){
          if(this.isDraw){
              if(this.jsonPoint.features.length >2){
                  this.jsonNamePoint.features = []
                  let pts = this.pointArray
                  pts = pts.concat([this.pointArray[0]])
                  this.jsonTemp.geometry.coordinates = [pts]
                  this.jsonNamePoint.features.push(...this.getLinePoint(this.jsonTemp.geometry.coordinates))
                  this.measureAreaEndDataT()
              }
          }
      },
      finishAreaMeasureDraw(){
          this.map.off("click",this.measureAreaClickEvent)
          this.map.off("dblclick",this.measureAreaDblclickEvent)
          this.map.off("mousemove",this.measureAreaMousemoveEvent)
          this.map.off('contextmenu',this.measureAreaContextmenuEvent)
          setTimeout(()=>{
              this.map.doubleClickZoom.enable()
          },0)
      },
      measureAreaEndDataT(){
            //处理边和中心点
          this.measureAreaJson.measurePoint.features.push(...this.jsonPoint.features)
          this.measureAreaJson.measureGeo.features.push(this.jsonTemp)
          this.measureAreaJson.measureNamePoint.features.push(...this.jsonNamePoint.features)
          this.map.getSource('measureAreaPointLayer').setData( this.measureAreaJson.measurePoint);
          this.map.getSource('measureAreaLayer').setData( this.measureAreaJson.measureGeo);
          this.map.getSource('measureAreaNameLayer').setData( this.measureAreaJson.measureNamePoint);
          this.clearAreaData()
      },
      clearAreaData(){
          this.jsonPoint.features = []
          this.jsonLine.features = []
          this.jsonNamePoint.features = []
          this.pointArray = []
          this.pointCoord=[]
          this.jsonTemp = {
              type: 'Feature',
              geometry: {
                  type: 'Polygon',
                  coordinates:[]
              },
          }
          this.map.getSource('measure-points').setData(this.jsonPoint);
          this.map.getSource('measure-line').setData(this.jsonLine);
          this.map.getSource('measure-line-name').setData(this.jsonNamePoint);
      },
      getLinePoint(array){
          let points={
              'type': 'FeatureCollection',
              'features': []
          }
          //面积
          let area = turf.area(turf.polygon(array))
          //中心点
          let center =turf.centroid(turf.polygon(array))
          points.features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: center.geometry.coordinates
              },
              properties:{
                  name: this.areaUomConversion(area),
              }
          })
          for(let i=0;i<array[0].length-1;i++){
              let lineCenter = turf.midpoint(turf.point(array[0][i]),turf.point(array[0][i+1]))
              let len = turf.distance(turf.point(array[0][i]),turf.point(array[0][i+1]),{units:'kilometers'})
              points.features.push({
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: lineCenter.geometry.coordinates
                  },
                  properties:{
                      name: this.lengthUomConversion(len*1000),
                  }
              })
          }
          return points.features
      },
      keyupMeasureEvent(e){
          if (e.keyCode === 27) {
              if(this.jsonPoint.features.length > 0){
                  if(this.measureToolChoose === 'len')
                      this.clearLengthData()
                  else
                      this.clearAreaData()
              }else{
                  this.finishMeasureDraw()
                  this.finishAreaMeasureDraw()
                  this.map.getCanvas().style.cursor = 'default';
                  document.getElementById("labelCanvas").style.cursor = 'default';
                  this.measureToolChoose = ''
                  document.removeEventListener('keyup', this.keyupMeasureEvent);
              }
          }
      },
      clearMeasureSource(){
          if (this.map.getLayer('measure-line-first-name')) {
              this.map.removeLayer('measure-line-first-name')
          }
          if (this.map.getLayer('measure-points')) {
              this.map.removeLayer('measure-points')
          }
          if (this.map.getSource('measure-points')) {
              this.map.removeSource('measure-points');
          }
          if (this.map.getLayer('measure-line-move')) {
              this.map.removeLayer('measure-line-move')
          }
          if (this.map.getSource('measure-line-move')) {
              this.map.removeSource('measure-line-move');
          }

          if (this.map.getLayer('measure-line-fill')) {
              this.map.removeLayer('measure-line-fill')
          }
          if (this.map.getLayer('measure-line')) {
              this.map.removeLayer('measure-line')
          }
          if (this.map.getSource('measure-line')) {
              this.map.removeSource('measure-line');
          }
          if (this.map.getLayer('measure-line-name')) {
              this.map.removeLayer('measure-line-name')
          }
          if (this.map.getSource('measure-line-name')) {
              this.map.removeSource('measure-line-name');
          }
      },
      clearAllMeasure(){
          this.clearMeasureSource()
          this.finishAreaMeasureDraw()
          this.finishMeasureDraw()
          this.measureToolChoose = ''
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          this.measureCardShow = false
          if((typeof this.mapMarker) === 'object'){
              this.mapMarker.remove()
          }
          if((typeof this.mapStartMarker) === 'object'){
              this.mapStartMarker.remove()
          }
          this.measureLengthJson.measureGeo.features = []
          this.measureLengthJson.measureNamePoint.features = []
          this.measureLengthJson.measurePoint.features = []
          this.map.getSource('measurePoints').setData( this.measureLengthJson.measurePoint);
          this.map.getSource('measureLine').setData( this.measureLengthJson.measureGeo);
          this.map.getSource('measureLineName').setData( this.measureLengthJson.measureNamePoint);
          this.measureAreaJson.measureGeo.features = []
          this.measureAreaJson.measureNamePoint.features = []
          this.measureAreaJson.measurePoint.features = []
          this.map.getSource('measureAreaPointLayer').setData( this.measureAreaJson.measurePoint);
          this.map.getSource('measureAreaLayer').setData( this.measureAreaJson.measureGeo);
          this.map.getSource('measureAreaNameLayer').setData( this.measureAreaJson.measureNamePoint);
          document.removeEventListener('keyup', this.keyupMeasureEvent);
      },
      //简单版push
      dataPushInFolder(temp,temp1){
          let data = {
              id:temp.id,
              name:temp.properties.name,
              type:temp.properties.type,
              visible:true,
              iconShow:false,
              geoJson:{
                  points:temp1,
                  geo:temp
              },
              children:[]
          }
          this.$store.state.addId = temp.id
          if(this.selectNode  === ''){
              this.$store.state.globeOperationMarkerList.push(data)
          }else{
              if(this.selectNode.data.type !=='folder'){
                  if(this.selectNode.parent ===null){
                      this.$store.state.globeOperationMarkerList.push(data)
                  }else{
                      if(Array.isArray(this.selectNode.parent.data)){
                          this.selectNode.parent.data.push(data)
                      }else{
                          this.selectNode.parent.data.children.push(data)
                      }
                  }
                  //this.$store.state.globeOperationMarkerList.push(data)
              }else{
                  this.selectNode.data.children.push(data)
              }
          }
          this.$refs.mainGlobeOperation.addMarkerToSelect(temp.id)
      },
      labelPushInFolder(data){
          this.$store.state.addId = data.id
          if(this.selectNode  === ''){
              this.$store.state.globeOperationMarkerList.push(data)
          }else{
              if(this.selectNode.data.type !=='folder'){
                  if(this.selectNode.parent ===null){
                      this.$store.state.globeOperationMarkerList.push(data)
                  }else{
                      if(Array.isArray(this.selectNode.parent.data)){
                          this.selectNode.parent.data.push(data)
                      }else{
                          this.selectNode.parent.data.children.push(data)
                      }
                  }
                  //this.$store.state.globeOperationMarkerList.push(data)
              }else{
                  this.selectNode.data.children.push(data)
              }
          }
          this.$refs.mainGlobeOperation.addMarkerToSelect(data.id)
      },
      //深拷贝
      deepClone(obj){
          let tmp = JSON.stringify(obj)
          return JSON.parse(tmp)
      },
      //单个删除操作
      removerMarker(node){

          const map={
              "point":this.removerPoint(node),
              "lineString":this.removeLine(node),
              "roadString":this.removeRoad(node),
              "circle":this.removePolygon(node),
              "rectangle":this.removePolygon(node),
              "polygon":this.removePolygon(node),
              "administrativeArea":this.removePolygon(node),
          }
          return map[node.data.type]
      },
      //删除点
      removerPoint(node){
          this.markerList.features = this.markerList.features.filter((item)=>{
              return item.id !== node.data.id
          })
         // this.map.getSource('markerLayer').setData(this.markerList)
      },
      removeLine(node){
          this.lineJson.linePoint.features = this.lineJson.linePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.lineJson.lineNamePoint.features = this.lineJson.lineNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
        //  this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
         // this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
        //  this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
      },
      removeRoad(node){
          this.roadJson.roadPoint.features =  this.roadJson.roadPoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.roadJson.roadNamePoint.features =this.roadJson.roadNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
        //  this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
         // this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
         // this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
      },
      removePolygon(node){
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
        //  this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
        //  this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          if(node.data.type !=='circle'){
              this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
              this.polygonJson.polygonLenPoint.features = this.polygonJson.polygonLenPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
          //    this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
         //     this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          }else{
              this.polygonJson.circleRadiusPoint.features = this.polygonJson.circleRadiusPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
          //    this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
          }
      },
      removeFolderMarker(node){
          let len = node.childNodes.length;
          if(len >0){
              for(let i=0;i< len;i++){
                  if(node.childNodes[i].data.type !=='folder'){
                      this.removerMarker(node.childNodes[i])
                  }
                  this.removeFolderMarker(node.childNodes[i])
              }
          }
          return 1
      },
      removerMarker1(node){

          const map={
              "point":this.removerPoint1(node),
              "lineString":this.removeLine1(node),
              "roadString":this.removeRoad1(node),
              "circle":this.removePolygon1(node),
              "rectangle":this.removePolygon1(node),
              "polygon":this.removePolygon1(node),
              "administrativeArea":this.removePolygon1(node),
          }
          return map[node.data.type]
      },
      removerPoint1(node){
          this.markerList.features = this.markerList.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      removeLine1(node){
          this.lineJson.linePoint.features = this.lineJson.linePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.lineJson.lineNamePoint.features = this.lineJson.lineNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
          this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
      },
      removeRoad1(node){
          this.roadJson.roadPoint.features =  this.roadJson.roadPoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.roadJson.roadNamePoint.features =this.roadJson.roadNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
          this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
      },
      removePolygon1(node){
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.filter((item)=>{
              return item.id !== node.data.id
          })
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          if(node.data.type !=='circle'){
              this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
              this.polygonJson.polygonLenPoint.features = this.polygonJson.polygonLenPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
              this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
              this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          }else{
              this.polygonJson.circleRadiusPoint.features = this.polygonJson.circleRadiusPoint.features.filter((item)=>{
                  return item.id !== node.data.id
              })
              this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
          }
      },
      //控制显隐
      mapSetData(){
          this.map.getSource('markerLayer').setData(this.markerList)
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
          this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
          this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
      }  ,
      hideControlFolderMarker(node){
          let len = node.childNodes.length;
          if(len >0){
              for(let i=0;i< len;i++){
                  if(node.childNodes[i].data.type !=='folder'){
                      this.hideControlMarker(node.childNodes[i])
                  }else{
                      this.hideControlFolderMarker(node.childNodes[i])
                  }
              }
          }
          return 1
      },
      hideControlMarker(node){
          let map={
              "point":(node)=>{this.hideControlPoint(node)},
              "lineString":(node)=>{this.hideControlLine(node)},
              "roadString":(node)=>{this.hideControlRoad(node)},
              "circle":(node)=>{this.hideControlPolygon(node)},
              "rectangle":(node)=>{this.hideControlPolygon(node)},
              "polygon":(node)=>{this.hideControlPolygon(node)},
              "administrativeArea":(node)=>{this.hideControlPolygon(node)},
          }
         map[node.data.type](node)
      },
      hideControlPoint(node){
          this.markerList.features = this.markerList.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
         // this.map.getSource('markerLayer').setData(this.markerList)
      },
      hideControlLine(node){
          this.lineJson.linePoint.features = this.lineJson.linePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.lineJson.lineNamePoint.features = this.lineJson.lineNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
        //  this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
        //  this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
        //  this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
      },
      hideControlRoad(node){
          this.roadJson.roadPoint.features =  this.roadJson.roadPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.roadJson.roadNamePoint.features =this.roadJson.roadNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
         // this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
        //  this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
        //  this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
      },
      hideControlPolygon(node){
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonLenPoint.features = this.polygonJson.polygonLenPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.circleRadiusPoint.features = this.polygonJson.circleRadiusPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
      },
      hideControlMarkerN1(node){
          let map={
              "point":(node)=>{this.hideControlPoint1(node)},
              "lineString":(node)=>{this.hideControlLine1(node)},
              "roadString":(node)=>{this.hideControlRoad1(node)},
              "circle":(node)=>{this.hideControlPolygon1(node)},
              "rectangle":(node)=>{this.hideControlPolygon1(node)},
              "polygon":(node)=>{this.hideControlPolygon1(node)},
              "administrativeArea":(node)=>{this.hideControlPolygon1(node)},
          }
          map[node.data.type](node)
      },
      hideControlPoint1(node){
          this.markerList.features = this.markerList.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      hideControlLine1(node){
          this.lineJson.linePoint.features = this.lineJson.linePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.lineJson.lineNamePoint.features = this.lineJson.lineNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
           this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
           this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
           this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
      },
      hideControlRoad1(node){
          this.roadJson.roadPoint.features =  this.roadJson.roadPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.roadJson.roadNamePoint.features =this.roadJson.roadNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
           this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
           this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
      },
      hideControlPolygon1(node){
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonNamePoint.features = this.polygonJson.polygonNamePoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.polygonLenPoint.features = this.polygonJson.polygonLenPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.polygonJson.circleRadiusPoint.features = this.polygonJson.circleRadiusPoint.features.map((item)=>{
              if(item.id === node.data.id){
                  item.properties.visible =  node.data.visible ? 'visible':'none'
              }
              return item
          })
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
      },
      //隐藏图层
      hideLayer(visibility){
          //点
          this.map.setLayoutProperty('markerList2','visibility',visibility)
          //线
          this.map.setLayoutProperty('lineLayer','visibility',visibility)
          this.map.setLayoutProperty('linePointLayer','visibility',visibility)
          this.map.setLayoutProperty('linePointSymbol','visibility',visibility)
          this.map.setLayoutProperty('lineNamePoint','visibility',visibility)
          //路线规划
          this.map.setLayoutProperty('roadLayer','visibility',visibility)
          this.map.setLayoutProperty('roadPointLayer','visibility',visibility)
          this.map.setLayoutProperty('roadPointSymbol','visibility',visibility)
          this.map.setLayoutProperty('roadNamePoint','visibility',visibility)
          //多边形
          this.map.setLayoutProperty('circleRadiusPoint','visibility',visibility)
          this.map.setLayoutProperty('polygonLayer','visibility',visibility)
          this.map.setLayoutProperty('polygonLineLayer','visibility',visibility)
          this.map.setLayoutProperty('polygonPointLayer','visibility',visibility)
          this.map.setLayoutProperty('polygonPointSymbol','visibility',visibility)
          this.map.setLayoutProperty('polygonNameLayer','visibility',visibility)
          this.map.setLayoutProperty('polygonLenLayer','visibility',visibility)
          //线的测量
          // this.map.setLayoutProperty('measurePoints','visibility',visibility)
          // this.map.setLayoutProperty('measureLineFirstName','visibility',visibility)
          // this.map.setLayoutProperty('measureLine','visibility',visibility)
          // this.map.setLayoutProperty('measureLineName','visibility',visibility)
          // //面积测量
          // this.map.setLayoutProperty('measureAreaLayer','visibility',visibility)
          // this.map.setLayoutProperty('measureAreaLineLayer','visibility',visibility)
          // this.map.setLayoutProperty('measureAreaPointLayer','visibility',visibility)
          // this.map.setLayoutProperty('measureAreaNameLayer','visibility',visibility)
      },
      getChildNameList(id){
          this.$axios.get('/authorApi/a-area-geo/getChildNameListById',{
              params:{
                  id:id
              }
          }).then((res)=>{
              if(res.data.status === 200){
                  this.provinceItems = res.data.data
              }
          })
      },
      //解析初始化文件
      initMapMarker(val){
          for(let i =0;i<val.length;i++){
              if(val[i].type !=='folder'){
                  this.addToMap(val[i])
              }
              this.initMapMarker(val[i].children)
          }
      },
      addToMap(val){
          let map={
              "point":(val)=>{this.addPointToMap(val)},
              "lineString":(val)=>{this.addLinToMap(val)},
              "roadString":(val)=>{this.addRoadToMap(val)},
              "circle":(val)=>{this.addCircleToMap(val)},
              "rectangle":(val)=>{this.addRectangleToMap(val)},
              "polygon":(val)=>{this.addPolygonToMap(val)},
              "administrativeArea":(val)=>{this.addAreaToMap(val)},
          }
          map[val.type](val)
      },
      addPointToMap(val){
          let point = {
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.markerList.features.push(point)
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      addLinToMap(val){
          let line = {
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.lineJson.lineGeo.features.push(line)
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          if(val.geoJson.points.length !==0){
              let lineName = {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: val.geoJson.points[0].geometry.coordinates
                  },
                  id: val.id,
                  properties:{
                      "type":'point',
                      "name": val.geoJson.geo.properties.name,
                      "visible":val.visible ? "visible":"none",
                      "country":"",
                      "addrName":"",
                      "imageList":[],
                      "secondId":'',
                  }
              }
              this.lineJson.lineNamePoint.features.push(lineName)
              this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
              this.lineJson.linePoint.features.push(...val.geoJson.points)
              this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
          }
      },
      addRoadToMap(val){
          let line = {
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.roadJson.roadGeo.features.push(line)
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          if(val.geoJson.points.length !==0){
              let lineName = {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: val.geoJson.points[0].geometry.coordinates
                  },
                  id: val.id,
                  properties:{
                      "type":'point',
                      "name": val.geoJson.geo.properties.name,
                      "visible":val.visible ? "visible":"none",
                      "country":"",
                      "addrName":"",
                      "imageList":[],
                      "secondId":'',
                  }
              }
              this.roadJson.roadNamePoint.features.push(lineName)
              this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
              this.roadJson.roadPoint.features.push(...val.geoJson.points)
              this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
          }
      },
      addCircleToMap(val){
          let circle={
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.polygonJson.polygonGeo.features.push(circle)
          let circleName={
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: val.geoJson.geo.properties.center
              },
              id: val.id,
              properties:{
                  "type":'point',
                  "name": val.geoJson.geo.properties.name,
                  "visible":val.visible ? "visible":"none",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "secondId":'',
              }
          }
          this.polygonJson.polygonNamePoint.features.push(circleName)
          let circleRadius = {
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: val.geoJson.geo.properties.center
              },
              id: val.id,
              properties:{
                  "type":'point',
                  "name": "半径："+this.lengthUomConversion(val.geoJson.geo.properties.len),
                  "visible":"none",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "secondId":'',
              }
          }
          let translation = turf.transformTranslate(circleRadius,val.geoJson.geo.properties.len/1000,90)
          this.polygonJson.circleRadiusPoint.features.push(translation)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
      },
      addRectangleToMap(val){
          let rectangle={
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.polygonJson.polygonGeo.features.push(rectangle)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          let rectangleName = {
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: val.geoJson.geo.properties.center
              },
              id: val.id,
              properties:{
                  "type":'point',
                  "name": val.geoJson.geo.properties.name,
                  "visible":val.visible ? "visible":"none",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "secondId":'',
              }
          }
          this.polygonJson.polygonNamePoint.features.push(rectangleName)
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          if(val.geoJson.points.length !==0){
              this.polygonJson.polygonPoint.features.push(...val.geoJson.points)
              this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          }
          let leftCenter = turf.midpoint(turf.point(val.geoJson.geo.geometry.coordinates[0][0]),turf.point(val.geoJson.geo.geometry.coordinates[0][3]))
          let leftLen = turf.distance(turf.point(val.geoJson.geo.geometry.coordinates[0][0]),turf.point(val.geoJson.geo.geometry.coordinates[0][3]),{units:'kilometers'})
          this.polygonJson.polygonLenPoint.features.push(
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: leftCenter.geometry.coordinates
                  },
                  id: val.id,
                  properties: {
                      "type":'point',
                      "name":this.lengthUomConversion(leftLen*1000),
                      "visible":"none",
                      "country":'',
                      "addrName":'',
                      "imageList":[],
                      "secondId":''
                  },
              }
          )
          let rightCenter = turf.midpoint(turf.point(val.geoJson.geo.geometry.coordinates[0][2]),turf.point(val.geoJson.geo.geometry.coordinates[0][3]))
          let rightLen = turf.distance(turf.point(val.geoJson.geo.geometry.coordinates[0][2]),turf.point(val.geoJson.geo.geometry.coordinates[0][3]),{units:'kilometers'})
          this.polygonJson.polygonLenPoint.features.push(
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: rightCenter.geometry.coordinates
                  },
                  id: val.id,
                  properties: {
                      "type":'point',
                      "name":this.lengthUomConversion(rightLen*1000),
                      "visible":"none",
                      "country":'',
                      "addrName":'',
                      "imageList":[],
                      "secondId":''
                  },
              }
          )
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
      },
      addPolygonToMap(val){
          let polygon={
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.polygonJson.polygonGeo.features.push(polygon)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          let polygonName = {
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: val.geoJson.geo.properties.center
              },
              id: val.id,
              properties:{
                  "type":'point',
                  "name": val.geoJson.geo.properties.name,
                  "visible":val.visible ? "visible":"none",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "secondId":'',
              }
          }
          this.polygonJson.polygonNamePoint.features.push(polygonName)
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          if(val.geoJson.points.length !==0){
              this.polygonJson.polygonPoint.features.push(...val.geoJson.points)
              this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          }
          // for(let i=0;i<val.geoJson.geo.geometry.coordinates[0].length-1;i++){
          //     let center = turf.midpoint(turf.point(val.geoJson.geo.geometry.coordinates[0][i]),turf.point(val.geoJson.geo.geometry.coordinates[0][i+1]))
          //     let len = turf.distance(turf.point(val.geoJson.geo.geometry.coordinates[0][i]),turf.point(val.geoJson.geo.geometry.coordinates[0][i+1]),{units:'kilometers'})
          //     this.polygonJson.polygonLenPoint.features.push(
          //         {
          //             type: 'Feature',
          //             geometry: {
          //                 type: 'Point',
          //                 coordinates: center.geometry.coordinates
          //             },
          //             id: val.id,
          //             properties: {
          //                 "type":'point',
          //                 "name":this.lengthUomConversion(len*1000),
          //                 "visible":"none",
          //                 "country":'',
          //                 "addrName":'',
          //                 "imageList":[],
          //                 "secondId":i+1
          //             },
          //         }
          //     )
          //     this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          // }
      },
      addAreaToMap(val){
          let area={
              type:'Feature',
              id: val.id,
              geometry: val.geoJson.geo.geometry,
              properties: val.geoJson.geo.properties
          }
          this.polygonJson.polygonGeo.features.push(area)
          let areaName={
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: val.geoJson.geo.properties.center
              },
              id: val.id,
              properties:{
                  "type":'point',
                  "name": val.geoJson.geo.properties.name,
                  "visible":val.visible ? "visible":"none",
                  "country":"",
                  "addrName":"",
                  "imageList":[],
                  "secondId":'',
              }
          }
          this.polygonJson.polygonNamePoint.features.push(areaName)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
      },
      //左侧列表状态与地球显示效果联动处理函数
      //点击联动
      mapMarkerStatus(id,width){
          this.pointMapStatus(id,width)
          this.lineMapStatus(id,width)
          this.roadMapStatus(id,width)
          this.polygonMapStatus(id,width)
      },
      pointMapStatus(id,width){
          this.markerList.features = this.markerList.features.map((item)=>{
              if(item.id === id){
                  item.properties.size =  width
              }
              return item
          })
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      lineMapStatus(id,width){
          //处理关于点的信息 加粗到4，控制点的显隐
          this.lineJson.linePoint.features = this.lineJson.linePoint.features.map((item)=>{
              if(item.id === id){
                  item.properties.visible =  'visible'
              }else{
                  item.properties.visible = 'none'
              }
              return item
          })
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>{
              if(item.id === id){
                  item.properties.width = width
              }
              return item
          })
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
      },
      roadMapStatus(id,width){

          this.roadJson.roadPoint.features =  this.roadJson.roadPoint.features.map((item)=>{
              if(item.id === id){
                  item.properties.visible = 'visible'
              }else{
                  item.properties.visible = 'none'
              }
              return item
          })
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.map((item)=>{
              if(item.id === id){
                  item.properties.width = width
              }
              return item
          })
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
      },
      polygonMapStatus(id,width){
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>{
              if(item.id === id){
                  item.properties.width =  width
              }
              return item
          })
          this.polygonJson.polygonPoint.features = this.polygonJson.polygonPoint.features.map((item)=>{
              if(item.id === id){
                  item.properties.visible = 'visible'
              }else{
                  item.properties.visible = 'none'
              }
              return item
          })
          this.polygonJson.polygonLenPoint.features.map((item)=>{
              if(item.id === id){
                  item.properties.visible =  'visible'
              }else{
                  item.properties.visible = 'none'
              }
              return item
          })
          this.polygonJson.circleRadiusPoint.features = this.polygonJson.circleRadiusPoint.features.map((item)=>{
              if(item.id === id){
                  item.properties.visible ='visible'
              }else{
                  item.properties.visible ='none'
              }
              return item
          })
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
      },
      //悬浮联动
      mapHoverMarkerStatus(data,width){
          let map={
              "point":(data,width)=>{this.pointHoverMapStatus(data,width)},
              "lineString":(data,width)=>{this.lineHoverMapStatus(data,width)},
              "roadString":(data,width)=>{this.roadHoverMapStatus(data,width)},
              "circle":(data,width)=>{this.polygonHoverMapStatus(data,width)},
              "rectangle":(data,width)=>{this.polygonHoverMapStatus(data,width)},
              "polygon":(data,width)=>{this.polygonHoverMapStatus(data,width)},
              "administrativeArea":(data,width)=>{this.polygonHoverMapStatus(data,width)},
          }
          map[data.type](data,width)


          // this.pointHoverMapStatus(id,width)
          // this.lineHoverMapStatus(id,width)
          // this.roadHoverMapStatus(id,width)
          // this.polygonHoverMapStatus(id,width)
      },
      pointHoverMapStatus(data,width){
          this.markerList.features = this.markerList.features.map((item)=>{
              if(item.id === data.id){
                  item.properties.size =  width
              }
              return item
          })
          this.map.getSource('markerLayer').setData(this.markerList)
      },
      lineHoverMapStatus(data,width){
          //线
          this.lineJson.lineGeo.features = this.lineJson.lineGeo.features.map((item)=>{
              if(item.id === data.id){
                  item.properties.width = width
              }
              return item
          })
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
      },
      roadHoverMapStatus(data,width){
          this.roadJson.roadGeo.features =  this.roadJson.roadGeo.features.map((item)=>{
              if(item.id === data.id){
                  item.properties.width = width
              }
              return item
          })
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
      },
      polygonHoverMapStatus(data,width){
          //多边形
          this.polygonJson.polygonGeo.features = this.polygonJson.polygonGeo.features.map((item)=>{
              if(item.id === data.id){
                  item.properties.width = width
              }
              return item
          })
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
      },
      nodeMouseover(data){
          if(data.type !=='folder'){
              this.hoverNodeId = data.id
              if(data.type === 'point'){
                  this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.size)+0.2)
              }else{
                  this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.width)+2)
              }

          }
          // if(!(this.selectNode !=='' && data.id ==this.selectNode.data.id)){
          //     if(data.type !='folder'){
          //         this.hoverNodeId = data.id
          //         if(data.type == 'point'){
          //             this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.size)+1)
          //         }else{
          //             this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.width)+2)
          //         }
          //     }
          // }
      },
      nodeMouseout(data){
          if(data.type !== 'folder'){
              this.hoverNodeId = ''
              if(data.type === 'point'){
                  this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.size)-0.2)

              }else{
                  this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.width)-2)
              }
          }
          // if(!(this.selectNode !=='' && data.id ===this.selectNode.data.id)){
          //     if(data.type != 'folder'){
          //         this.hoverNodeId = ''
          //         if(data.type == 'point'){
          //             this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.size)-1)
          //         }else{
          //             this.mapHoverMarkerStatus(data,this.deepClone(data.geoJson.geo.properties.width)-2)
          //         }
          //     }
          // }
      },
      //左侧按钮点击隐藏方法
      changeLeftBarToOthers(){
          //数据列表的方法
          this.clearDataListEffect()
          //图层方法的列表
          this.clearLayerListEffect()
          //清除监听
          clearInterval(this.messageTime)
          this.messageShowQueue=[]
          //this.messageQueue=[]
          this.messageShowTime = 0
      },
      clearDataListEffect(){
          //清除测量的数据
          this.clearAllMeasure()
          //关闭卡片
          this.closeEditCard()
          //清除地图上的事件
          this.cleanMapOnEvent()
          this.isDraw = false;
          this.map.getCanvas().style.cursor = 'default';
          document.getElementById("labelCanvas").style.cursor = 'default';
          //清除选择按钮
          this.drawToolsOldChose = 'selectTool'
          this.drawToolsChoose = 'selectTool'
          //隐藏图层
          this.hideLayer('none')
      },
      //是否展示数据列表图层
      isShowDataListEffect(val){
          if(val ==='false')
              this.clearDataListEffect()
          else{
              this.layerCardShow = false
              this.layerCardTypeSelect = ''
              this.$store.state.selectLayerTreeNode = ''
              this.hideLayer('visible')
          }
      },
      clearLayerListEffect(){
          this.$store.state.selectLayerTreeNode = ''
          //this.$refs.mainGlobeOperation.cancelLayerTreeSelect()
      },
      clearExistingData(val){
          //清理点
          this.markerList.features =[]
          //清理线
          this.lineJson.lineGeo.features =[]
          this.lineJson.linePoint.features =[]
          this.lineJson.lineNamePoint.features =[]
          //清理路线
          this.roadJson.roadGeo.features = []
          this.roadJson.roadPoint.features = []
          this.roadJson.roadNamePoint.features = []
          //清理面
          this.polygonJson.polygonGeo.features = []
          this.polygonJson.polygonPoint.features = []
          this.polygonJson.polygonNamePoint.features = []
          this.polygonJson.polygonLenPoint.features = []
          this.polygonJson.circleRadiusPoint.features = []
          this.map.getSource('markerLayer').setData(this.markerList)
          this.map.getSource('lineLayer').setData(this.lineJson.lineGeo);
          this.map.getSource('linePointLayer').setData(this.lineJson.linePoint);
          this.map.getSource('lineNamePoint').setData(this.lineJson.lineNamePoint)
          this.map.getSource('roadNamePoint').setData(this.roadJson.roadNamePoint)
          this.map.getSource('roadPointLayer').setData(this.roadJson.roadPoint)
          this.map.getSource('roadLayer').setData(this.roadJson.roadGeo)
          this.map.getSource('polygonLayer').setData(this.polygonJson.polygonGeo);
          this.map.getSource('circleRadiusPoint').setData(this.polygonJson.circleRadiusPoint);
          this.map.getSource('polygonNameLayer').setData(this.polygonJson.polygonNamePoint);
          this.map.getSource('polygonLenLayer').setData(this.polygonJson.polygonLenPoint);
          this.map.getSource('polygonPointLayer').setData(this.polygonJson.polygonPoint);

          this.closeEditCard()
          this.initMapMarker(val)

      },

      setLoading(val){
          this.showLoadingDialog = val
      },

      //点击方法
      // nodeClick(node){
      //     if(this.$store.state.handleNodeOption == 'selectNode'){
      //         this.closeEditCard()
      //         if(this.selectNode !==''){
      //             if(node.data.type !=='folder'){
      //                 //如何hover情况下被选中
      //                 if(node.data.id === this.hoverNodeId){
      //                     if(node.data.type ==='point'){
      //                         node.data.geoJson.geo.properties.size = node.data.geoJson.geo.properties.size -1
      //                     }else{
      //                         node.data.geoJson.geo.properties.width = node.data.geoJson.geo.properties.width-2
      //                     }
      //                 }
      //                 if(node.data.type ==='administrativeArea'){
      //                     this.currentBoundary.geometry.type = this.deepClone(node.data.geoJson.geo.geometry.type)
      //                     this.currentBoundary.properties.center = this.deepClone(node.data.geoJson.geo.properties.center)
      //                     this.currentBoundary.geometry.coordinates = this.deepClone(node.data.geoJson.geo.geometry.coordinates)
      //                     this.areaName =  this.deepClone(node.data.geoJson.geo.properties.graphArea)
      //                 }
      //                 this.selectItems.geo = this.deepClone(node.data.geoJson.geo)
      //                 this.selectItems.points = this.deepClone(node.data.geoJson.points)
      //                 this.propertiesEditCardShow = true
      //                 this.mapFitBoundary(node.data.geoJson.geo)
      //                 //地图数据处理
      //                 if(this.selectNode.data.type ==='point'){
      //                     this.mapMarkerStatus(node.data.id,node.data.geoJson.geo.properties.size)
      //                 }else{
      //                     this.mapMarkerStatus(node.data.id,node.data.geoJson.geo.properties.width)
      //                 }
      //             }else{
      //                 this.mapMarkerStatus(node.data.id,2)
      //                 this.closeEditCard()
      //             }
      //         }else{
      //             this.closeEditCard()
      //         }
      //     }
      // }


      //'''''''''''''''''''''''''''''''''''''''''一下内容是图层列表的操作'''''''''''''''''''''''''''''''''''''''''''''''''
      clickImportAnnexDataDialog(){
          if(this.$store.state.handleNodeOption === 'modify'){
              this.notSavedDialog = true
          }else{
              //dialog打开
              this.importAnnexDataDialogShow = true
              if(this.drawToolsChoose !=='selectTool'){
                  this.drawToolsOldChose = 'selectTool'
                  this.drawToolsChoose = 'selectTool'
                  this.cleanMapOnEvent()
                  this.map.getCanvas().style.cursor = 'default'
                  document.getElementById("labelCanvas").style.cursor = 'default';
              }
              this.closeEditCard()
          }

      },
      closeImportAnnexDataDialog(){
          this.isViewAnnexData = false
          this.importAnnexDataDialogShow = false
      },
      closeLayerCardShow(){
          this.layerCardShow = false
          this.layerCardTypeSelect = ''
          this.$store.state.selectLayerTreeNode = ''
          this.$refs.mainGlobeOperation.cancelLayerTreeSelect()
      },
      //查看数据
      viewAnnexData(){
          this.isViewAnnexData = true
          this.importAnnexDataDialogShow = true
      },
      //另存为我的文件
      saveAsMyData(){
          let data = new FormData()
          data.append("layerId",this.$store.state.selectLayerTreeNode.data.layerId)
          this.$axios.post('/authorApi/userAnnex/copyAnnex',data)
              .then((res)=>{
                  if(res.data.status ===200){
                      this.$store.state.selectLayerTreeNode = ''
                      this.$refs.mainGlobeOperation.cancelLayerTreeSelect()
                      this.importAnnexDataDialogShow = true
                  }else{
                      this.$store.state.snackbarShow = true
                      this.$store.state.snackbarText = res.data.message
                      this.$store.state.snackbarType = 'error'
                  }
              }).catch(()=>{
              this.$store.state.snackbarShow = true
              this.$store.state.snackbarText = '保存失败'
              this.$store.state.snackbarType = 'error'
          })

          // if(this.$store.state.currFolderRole ===3 &&this.$store.state.currFolderTeamSave === 0){
          //     this.$store.state.snackbarShow = true
          //     this.$store.state.snackbarText = "暂无权限，请联系创建者"
          //     this.$store.state.snackbarType = 'error'
          // }else{
          //
          // }
      },

      //
      pushNoReadData(val){
          //数据push进去
          this.messageQueue.push(val)
      },
      refreshMessage(){
          this.messageTime = setInterval(()=>{
              if(this.mapboxInit){
                  if(this.$store.state.currFolderType === 1){
                      if(this.messageQueue.length !==0){
                          this.messageShowTime = 0
                          let ele =  this.messageQueue.shift()
                          this.messageShowQueue.push(ele)
                      }else{
                          this.messageShowTime = this.messageShowTime+1
                          if( this.messageShowTime >=5){
                              this.messageShowQueue=[]
                              this.messageShowTime = 0
                          }
                      }
                  }

              }
          },1000)
      },

      createLayerOk(id){
          this.isViewAnnexData = false
          this.importAnnexDataDialogShow = false
          this.$refs.mainGlobeOperation.successToLayer(id)
      },

      selectLayerTypeShow(val){
              if(this.$store.state.currFolderType !==0){
                  if(this.layerCardTypeSelect !== val){
                      this.$axios.get('/authorApi//z-geo-file/canEditLayer', {
                          params:{
                              fileId:this.$store.state.currFolderId
                          }
                      }).then((res)=>{
                          if(res.data.status === 200){
                              // if(val === 'histogram'){
                              //     this.setHisShow()
                              // }else{
                              //     this.setHishide()
                              // }
                              this.layerCardTypeSelect = val
                          }else{
                              this.$store.state.snackbarShow = true
                              this.$store.state.snackbarText =res.data.message
                              this.$store.state.snackbarType = 'error'
                          }
                      })
                  }
              }else{
                  this.layerCardTypeSelect = val
              }
      },

      hideHisLayer(visibility){
          this.map.setLayoutProperty('hisMapLayer','visibility',visibility)
      },
      createSquaredByPoint(coordinates,offset){
          let smx = coordinates[0];
          let smy = coordinates[1];
          let offset_int = parseFloat(offset);
          return [[smx,smy],[smx,smy + offset_int],[smx - offset_int,smy + offset_int],[smx - offset_int,smy],[smx,smy]];
      },
      // setHisShow(){
      //     //数据处理
      //     this.$store.state.selectLayerTreeNode.data.geojson.features.forEach(item=>{
      //         let array = this.createSquaredByPoint(item.geometry.coordinates,this.breadth);
      //         this.histogramList.features.push({
      //             "geometry":{
      //                 "coordinates":[
      //                     array
      //                 ],
      //                 "type":"Polygon"
      //             },
      //             "type":"Feature",
      //             "properties":item.properties
      //         })
      //     })
      //     console.log(this.histogramList)
      //     this.map.getSource('hisMap').setData(this.histogramList)
      //     this.hideHisLayer('visible')
      // },
      // setHishide(){
      //     this.histogramList.features = []
      //     this.map.getSource('hisMap').setData(this.histogramList)
      //      this.hideHisLayer('none')
      // }
  },
  mounted() {
      this.getCountryBoundary('100000')
      this.getChildrenList('100000')
      this.getChildNameList(100000)
  }
}
</script>

<style >
    .measure-result {
        /*height: 28px;*/
        /*line-height: 28px;*/
        font-size: 14px;
        /*text-shadow: 1px 1px 1px rgba(0,0,0,1),-1px -1px 1px rgba(0,0,0,1);*/
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.7);
        justify-content: center;
        align-items: center;
        display: flex;
        padding: 0 3px;
        margin-bottom: 5px;
    }
</style>
